import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete, Box, Button, Chip, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton,
  InputLabel,
  ListItem, ListItemText,
  MenuItem, OutlinedInput, Paper, Select, Tab, Table, TableBody, TableCell, TableHead,
  TableRow, Tabs, TextField, Tooltip, Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import {
  COMMON_STYLE, DROP_FREQ, Eye_Type, language, Medication_dosages, NEW_DOC_DURATION_LIST,
  NEW_DOC_EYE_TYPE, OPT_MED_DURATION, OPT_MED_TAP_DURATION, Prescription_Days, UMA_USAGE_LIST,
  USAGE_TYPE
} from '../../../../Utility/Constants';
import { Colors } from '../../../../Styles/Colors';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import HistoryIcon from '@mui/icons-material/History';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { HighAlertDrugPopup, useDebounce } from '../../../../Components/Common Components/CommonComponents';
import { DateTime } from 'luxon';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {ImagePaths} from '../../../../Utility/ImagePaths';

let is_save_transmit = false;
const UmaMedication = React.forwardRef((props, ref) => {
  const [medication, setMedication] = useState({
  patientId: '',
  appointmentId: '',
  clinicId: '',
  doctorId: '',
  templateList: [],
  selectedTemplate: null,
  languageList: language,
  selectedLanguage: { label: 'English', value: 'english' },
  medicationList: [],
  openMedicationPopup: false,
  selectedTab: 'one',
  pharmacyList: [],
  selectedPharmacy: null,
  externalDrug: false,
  MediTaperData: [],
  // Medicaion State
  medSearchDrug: null,
  medSearchDrugSugg: [],
  medGenericName: null,
  medGenericNameSugg: [],
  medDrugFreq: [],
  // External State
  extSearchDrug: '',
  extSearchDrugSugg: [],
  extGenericName: '',
  extGenericNameSugg: [],

  exttapSearchDrug: '',
  exttapSearchDrugSugg: [],
  exttapGenericName: '',
  exttapGenericNameSugg: [],

  fo_external_drug_id: null,
  // Common MED & EXT States
  dosageStrength: '',
  dosageType: '',
  dosageTypeSugg: Medication_dosages,
  selectedEye: '',
  eyeList: Eye_Type,
  selectedFreq: '',
  FreqSugg: [],
  dupFreqSugg: '[]',
  durationTime: '',
  durationType: 'Days',
  durationTypeSugg: OPT_MED_DURATION,
  tapMedDuration: OPT_MED_TAP_DURATION,
  selectedUsage: '',
  usageSugg: USAGE_TYPE,
  quantity: '',
  medExtTapComments: '',
  avalQty: '0',
  drugId: null,
  medFavorite: false,
  // Taper Med States
  tapSearchDrug: null,
  tapSearchDrugSugg: [],
  tapDrugFreq: [],
  selectedDate: new Date(),
  tapUnit: '',
  tapUnitType: '',
  tapDuration: '',
  tapDurationType: 'Day(s)',
  tapDurationSugg: OPT_MED_TAP_DURATION,
  tapTabletFreq: null,
  tapDropsFreq: null,
  tapTabletFreqSugg: [],
  tapDropsFreqSugg: DROP_FREQ,
  tapMedDetails: [],
  tapGenericName: null,
  tapGenericNameSugg: [],
  selectedId: null,
  reduceBy: '',
  rgtTapEdit: false,
  rgtTapIndex: null,
  // prev Prescrip States
  openPrevPrescripPopup: false,
  prevPrescripData: [],
  // Fav Prescrip States
  openFavPrescripPopup: false,
  favPrescripSugg: [],
  selectedFavPrescrip: [],

    drugSearchFor: 1,
    dupDosageType: JSON.stringify(Medication_dosages),
    newFreq: '',
    steroidTablet: "STEROID TABLETS",
    drop: 'drop',
    isLftEdit: false,
    lftSelectedIndex: null,
    is_from_taper: false,
    isEdit: false,
    selectedIndex: null,
    favSaveClicked: false,
    printLoad: false,
    fromPrevPrespAdd: false,
    openAddNewTemplatePopup: false,
    templateId: null,
    templateName: '',
    tempType: '',
    templateClicked: false,
    latest_prescription: {},
    editData: null,
    dupMediTaperData: '[]',
    AfterApi: false,
    fromEdit: false,
    accordionOpen: false,
    btnClked: false,

    //Dropdown in Medication
    selective_days: [],
    selectedDrug: '',
    is_high_alert: false,
    is_look_alike: false,
    is_sound_alike: false,
    highAlert: false,
    lookAlikeDrugs: [],
    SoundAlikeDrugs: [],
    enable_drug_alert: false,
    FavDrugData: [],
    ReasonSuggestionList: [],
    suggLoader: false,
    commentsFieldKey: 0
  })
  const [medSearchDrug, setMedDrugSearch] = useState('')
  const [searchExtBrand, setSearchExtBrand] = useState('')
  const medDrugSearchQuery = useDebounce(medSearchDrug, 500)
  const extBrandSearchQuery = useDebounce(searchExtBrand, 500)
  const [recallModalOpen, setRecallModalOpen] = useState(false);
  const [recallReason, setRecallReason] = useState('');
  const [recallError, setRecallError] = useState('');
  const [currentMedication, setCurrentMedication] = useState(null);
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - MEDICATION`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - MEDICATION`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const highAlertpopupClose = () => {
    onClearHandler()
    setMedication(prev => ({
      ...prev,
      highAlert: false,
      FavDrugData: []
    }));
  }

  const highAlertpopupConfirm = () => {
    setMedication(prev => ({
      ...prev,
      highAlert: false,
    }));
    if (medication?.FavDrugData.length <= 0) {
      getDrugData(true);
    }
    if (medication?.FavDrugData.length > 0) {
      setMedication(prev => ({
        ...prev,
        selectedFavPrescrip: medication?.FavDrugData.length > 0 ? medication?.FavDrugData : []
      }));
    }
    setTimeout(() => {
      setMedication(prev => ({
        ...prev,
        FavDrugData: []
      }));
    }, 500);
  }

  React.useImperativeHandle(ref, () => ({
    performMedicationAction: () => {
      console.log("Medication")
    }
  }))

  useEffect(async () => {
    let drugSearch = localGetItem('drug_search') !== 'undefined' ? JSON.parse(localGetItem('drug_search')) : 1
    let enable_drug_alert = localGetItem('enable_drug_alert') ? JSON.parse(localGetItem('enable_drug_alert')) : false
    let prescriptionLanguage = localGetItem('prescription_language') ? JSON.parse(localGetItem('prescription_language')) : 'english'
    is_save_transmit = localGetItem('prescription_save_transmit') === 'true' ? true : false;
    let selectedLang = { label: prescriptionLanguage, value: prescriptionLanguage.toLowerCase() }
    setMedication((prev) => ({ ...prev, drugSearchFor: drugSearch, enable_drug_alert: enable_drug_alert }))
  }, [])

  useEffect(() => {
    if (props.props.loginUserInfo) {
      setMedication((prev) => ({
        ...prev,
        pharmacyList: props.props.loginUserInfo?.pharmacy_data || [],
        selectedPharmacy: props.props.loginUserInfo?.pharmacy_data[0]
      }))
    }
  }, [props.props.loginUserInfo])

  useEffect(() => {
    // Before Drug Search
    if (medDrugSearchQuery) {
      getDrugNameSearch()
    } else {
      setMedication((prev) => ({
        ...prev,
        medSearchDrugSugg: [],
        medGenericName: null,
        medGenericNameSugg: [],
        dosageStrength: '', dosageType: '',
        medFavorite: false, drugId: null,
        dosageTypeSugg: JSON.parse(medication.dupDosageType)
      }))
    }
    // After Drug Select
    if (medication.medSearchDrug || medication.tapSearchDrug) {
      getDrugData()
    }
    if (extBrandSearchQuery) {
      getExternalDrugSearch()
    } else {
      setMedication((prev) => ({
        ...prev,
        extSearchDrugSugg: [],
        extGenericName: '',
        extGenericNameSugg: [],
        dosageStrength: '', dosageType: '',
        medFavorite: false, drugId: null,
        dosageTypeSugg: JSON.parse(medication.dupDosageType),
        fo_external_drug_id: null,

        exttapSearchDrugSugg: [],
        exttapGenericName: '',
        exttapGenericNameSugg: [],
      }))
    }

    if (
      (medication.favSaveClicked && medication.selectedFavPrescrip?.length > 0) ||
      (medication.fromPrevPrespAdd && medication.prevPrescripData?.length > 0) ||
      (medication.selectedTemplate !== null && medication.templateClicked && medication.selectedTemplate?.medication?.length > 0)
    ) {
      postMedicationData()
    }

    if (medication.printLoad) {
      getMedicationPrint()
    }

  }, [
    medDrugSearchQuery, medication.medSearchDrug, extBrandSearchQuery,
    medication.tapSearchDrug, medication.favSaveClicked, medication.selectedFavPrescrip,
    medication.printLoad, medication.fromPrevPrespAdd, medication.selectedTemplate,
    medication.templateClicked
  ])

  useEffect(() => {
    setMedication((prev) => ({...prev, accordionOpen: prev?.medicationList?.length > 0}))
  }, [medication?.medicationList])

  //handle for dropdown 
  const handleChange = (event) =>{
    const {
      target: {value},
    } = event;
    // setMedication({
    //   ...Medication
    //  selective_days: typeof value === 'string' ? value.split(',') : value,
    // })
    setMedication((prev) =>({
       ...prev,
      selective_days: typeof value === 'string' ? value.split(',') : value,
    }))
  }

  const getDiscReasonSugg = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PRESCRIPTION_COMMENTS + `?clinic_id=${props?.props?.clinic_id}`)
        .then((response) => {
          if (response.data.status === "success") {
            setMedication((prev) => ({ ...prev, ReasonSuggestionList: response?.data?.data || [] }))
          } else {
            errorMessage(response.data?.message)
          }
        }).catch((error) => {
          errorMessage(error?.message)
        })
    } catch (e) {
      errorMessage(e?.message)
    }
  }

  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "h" && !medication.suggLoader) {
      event.preventDefault()
      setMedication((prev) => ({ ...prev, suggLoader: true }))
      postSuggest()
    }
  }

  const postSuggest = () => {
    try {
      const selection = window.getSelection()
      const selectedText = selection?.toString()?.trim()
      if (CommonValidation.removeSpace(selectedText) === "") {
        setTimeout(() => setMedication((prev) => ({ ...prev, suggLoader: false })), 2000)
        return errorMessage("Select the text to be added as a suggestion.")
      }
      const data = { reason: CommonValidation.removeSpace(selectedText) }
      RestAPIService.create(data, Serviceurls.DOC_PRESCRIPTION_COMMENTS + `?clinic_id=${props?.props?.clinic_id}`)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            getDiscReasonSugg()
            setTimeout(() => setMedication((prev) => ({ ...prev, suggLoader: false })), 2000)
          }
        }).catch((error) => {
          setTimeout(() => setMedication((prev) => ({ ...prev, suggLoader: false })), 2000)
          errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      setTimeout(() => setMedication((prev) => ({ ...prev, suggLoader: false })), 2000)
      errorMessage(error.message)
    }
  }

  const removeSuggList = (Sugg) => {
    try {
      const data = { perscription_id: Sugg?.id || "" }
      RestAPIService.delete(`${Serviceurls.DOC_PRESCRIPTION_COMMENTS}?clinic_id=${props?.props?.clinic_id}`, data)
        .then(response => {
          if (response.data.status === "success") {
            successMessage(response.data.message)
            getDiscReasonSugg()
          }
        })
        .catch(e => {
          errorMessage(e?.response?.data?.status === 'fail' ? e.response.data.message : e.message)
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  useEffect(() => {
    getDiscReasonSugg()
    document.addEventListener("keydown", handleKeyDown)
    return () => document.removeEventListener("keydown", handleKeyDown)
  }, [])

  const convertDayToNumber = (day) => {
    switch (day) {
      case "Sunday":
        return 0;
      case "Monday":
        return 1;
      case "Tuesday":
        return 2;
      case "Wednesday":
        return 3;
      case "Thursday":
        return 4;
      case "Friday":
        return 5;
      case "Saturday":
        return 6;
      default:
        return null;
    }
  };

  const convertNumberToDay = (number) => {
  switch (number) {
    case 0:
      return "Sunday";
    case 1:
      return "Monday";
    case 2:
      return "Tuesday";
    case 3:
      return "Wednesday";
    case 4:
      return "Thursday";
    case 5:
      return "Friday";
    case 6:
      return "Saturday";
    default:
      return null;
  }
};

  const expandInstruction = (item) => {
    let value = '';
    switch (item) {
      case 'BF':
        value = 'Before Food'
        break;
      case 'AF':
        value = 'After Food'
        break;
      case 'EA':
        value = 'External Application'
        break;
      case 'ES':
        value = 'Empty Stomach'
        break;
      case 'WF':
        value = 'With Food'
        break;
      case 'IA':
        value = 'Internal Application'
        break;
      default: break;
    }
    return value;
  }

  const apicalls = async () => {
    await getMedicationFreqList()
    await getFrequenctList()
    await getDrugFavoriteList()
    await getMedicationData()
    await getMedicationTemplateData()
    await getPrevMedicationData()
  }

  // DRUG SEARCH GET ====>
  const getDrugNameSearch = async () => {
    try {
      let params = '';
      if (medication.selectedTab === 'one') {
        if (medication.drugSearchFor === 1) {
          params = `?brand_name=${medDrugSearchQuery}&generic_name=&clinic_id=${props?.props?.clinic_id}&pharmacy_id=${medication.selectedPharmacy?.pharmacy_id}`
        } else if (medication.drugSearchFor === 2) {
          params = `?brand_name=&generic_name=${medDrugSearchQuery}&clinic_id=${props?.props?.clinic_id}&pharmacy_id=${medication.selectedPharmacy?.pharmacy_id}`
        } else {
          params = `?search_key=${medDrugSearchQuery}&brand_name=&generic_name=&clinic_id=${medication.clinicId}&pharmacy_id=${medication.selectedPharmacy?.pharmacy_id}`
        }
      } else {
        params = `?brand_name=${medDrugSearchQuery}&clinic_id=${props?.props?.clinic_id}&pharmacy_id=${medication.selectedPharmacy?.pharmacy_id}&is_tapper_meds=true`
      }
      const response = await RestAPIService.getAll(Serviceurls.DOC_OPT_FREQUENT_MEDICATION + params)
      if (response?.data?.status === 'success') {
        const data = response?.data?.data
        const foundSet = new Set();
        const uniqueArray = data?.filter((item) => {
          if (foundSet.has(item.drug_name)) return false;
          foundSet.add(item.drug_name);
          return true;
        });
        setMedication((prev) => ({
          ...prev,
          medSearchDrugSugg: medication.selectedTab === 'one' ?
            medication.drugSearchFor === 1 ? uniqueArray : data : [],
          tapSearchDrugSugg: medication.selectedTab === 'two' ? uniqueArray : [],
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // AFTER DRUG SEARCH GET ====>
  const getDrugData = async (skipHighAlertCheck = false) => {
    try {
      let search = ''
      if (medication.selectedTab === 'one') { search = encodeURIComponent(medication.medSearchDrug) } else { search = encodeURIComponent(medication.tapSearchDrug) }
      let params = `?brand_name=${search}&clinic_id=${props.props.clinic_id}&pharmacy_id=${medication.selectedPharmacy?.pharmacy_id}`;
      const response = await RestAPIService.getAll(Serviceurls.DOC_OPT_MEDICATION_DETAILS + params)
      if (response?.data?.status === 'success') {
        let responseData = response?.data?.data

        const hasHighAlert = responseData?.some(
          item =>
            item?.is_high_alert === true ||
            item?.is_look_alike === true ||
            item?.is_sound_alike === true
        );

        if (hasHighAlert && !skipHighAlertCheck && medication?.enable_drug_alert && !medication.fromEdit) {
          setMedication(prev => ({
            ...prev,
            selectedDrug: responseData[0]?.['drug_name'] || '',
            is_high_alert: responseData[0]?.['is_high_alert'] || false,
            is_look_alike: responseData[0]?.['is_look_alike'] || false,
            is_sound_alike: responseData[0]?.['is_sound_alike'] || false,
            lookAlikeDrugs: responseData[0]?.['look_alike_drugs'] || [],
            SoundAlikeDrugs: responseData[0]?.['sound_alike_drugs'] || [],
            highAlert: true,
            pendingDrugData: responseData,
          }));
          return;
        }

        const finalData = medication.skipHighAlertCheck ? (medication.pendingDrugData[0] || responseData[0]) : responseData[0];

        if (medication.selectedTab === 'one') {
          let hasDosage = JSON.parse(medication.dupDosageType)?.some(item => (item.label)?.toLowerCase() === (finalData?.dosage_type)?.toLowerCase())
          let addDosage = [...JSON.parse(medication.dupDosageType), { value: finalData?.dosage_type, label: finalData?.dosage_type, change_count: 0 }]
          setMedication((prev) => ({
            ...prev,
            drugId: (finalData?.drug_ms_id || finalData?.drug_id),
            medGenericName: medication.fromEdit ? medication.medGenericName : responseData?.length > 1 ? null : finalData?.generic_name,
            dosageStrength: medication.fromEdit ? medication.dosageStrength : responseData?.length > 1 ? '' : finalData?.dosage_strength,
            dosageType: medication.fromEdit ? medication.dosageType : responseData?.length > 1 ? '' : finalData?.dosage_type,
            avalQty: medication.fromEdit ? medication.avalQty : responseData?.length > 1 ? '0' : finalData?.quantity,
            medGenericNameSugg: responseData,
            dosageTypeSugg: responseData?.length > 1 ? JSON.parse(medication.dupDosageType) : (hasDosage ? JSON.parse(medication.dupDosageType) : addDosage),
            medFavorite: medication.fromEdit ? medication.medFavorite : responseData?.length > 1 ? false : finalData?.is_favorite,
          }))
          if (!medication.fromEdit) {
            let latest_prescription = responseData?.length > 1 ? null : finalData?.latest_prescription
            autoFetchDrugDetails(latest_prescription)
          }
        } else {
          let tapUnitType = medication.dosageType?.toLowerCase()?.includes(medication.steroidTablet?.toLowerCase())
          setMedication((prev) => ({
            ...prev,
            drugId: (finalData?.drug_ms_id || finalData?.drug_id),
            tapGenericName: medication.fromEdit ? medication.tapGenericName : responseData?.length > 1 ? null : finalData?.generic_name,
            dosageStrength: medication.fromEdit ? medication.dosageStrength : responseData?.length > 1 ? '' : finalData?.dosage_strength,
            dosageType: medication.fromEdit ? medication.dosageType : responseData?.length > 1 ? '' : finalData?.dosage_type,
            avalQty: medication.fromEdit ? medication.avalQty : responseData?.length > 1 ? '0' : finalData?.quantity,
            tapGenericNameSugg: responseData,
            medFavorite: medication.fromEdit ? medication.medFavorite : responseData?.length > 1 ? false : finalData?.is_favorite,
            tapUnitType: medication.fromEdit ? tapUnitType : responseData?.length > 1 ? '' :
              finalData?.dosage_type?.toLowerCase()?.includes(medication.steroidTablet?.toLowerCase()) ? 'Mg' : 'Drops',
            latest_prescription: medication.fromEdit ? null : responseData?.length > 1 ? {} : finalData?.latest_prescription
          }))
        }
        setMedication(prev => ({
          ...prev,
          pendingDrugData: null,
        }));
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const autoFetchDrugDetails = (data) => {
    let hasData = data !== null ? Object.keys(data)?.length > 0 : false
    if (hasData) {
      const drugValue = data?.duration?.split(" ");
      const [numStr, textStr] = drugValue?.length === 1 ? [drugValue, 'Days'] : drugValue?.length >= 2 ? drugValue : ["", data?.duration];
      setMedication((prev) => ({
        ...prev,
        selectedEye: data?.eye_type === 'RE' ? 'Right Eye (OD)' : data?.eye_type === 'LE' ? 'Left Eye (OS)' : 'Both (OU)',
        selectedFreq: data?.frequency__description,
        durationTime: numStr || '',
        durationType: textStr || 'Days',
        selectedUsage: data?.instructions,
        quantity: data?.quantity,
        medExtTapComments: data?.comments
      }))
    }
  }
  // EXTERNAL DRUG SEARCH ====>
  const getExternalDrugSearch = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.DOC_OPT_EXTERNAL_DRUG + `?brand_name=${searchExtBrand}&generic_name=`)
      if (response?.data?.status === 'success') {
        let responseData = response?.data?.data
        if (medication.selectedTab === 'one') {
          setMedication((prev) => ({ ...prev, extSearchDrugSugg: responseData || [] }))
        } else {
          setMedication((prev) => ({ ...prev, exttapSearchDrugSugg: responseData || [] }))
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // DRUG FREQUENCY GET ===>
  const getMedicationFreqList = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_DRUG_FREQ + '?pharmacy_id=' + medication.selectedPharmacy?.pharmacy_id)

      if (response?.data?.status === 'success') {
        setMedication((prev) => ({
          ...prev,
          medDrugFreq: response?.data?.drugs || [],
          tapDrugFreq: response?.data?.tapper_drugs || []
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // FREQUENCY GET ===>
  const getFrequenctList = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.DOC_OPT_MEDICATION_FREQUENCY)

      if (response?.data?.status === 'success') {
        let data = response.data.data
        let taper_data = response?.data?.tapper_data
        const uniqueArray = [...new Set(data)];
        const tapUniqueArray = [...new Set(taper_data)]
        setMedication((prev) => ({
          ...prev,
          FreqSugg: uniqueArray || [],
          dupFreqSugg: JSON.stringify(uniqueArray) || '[]',
          tapTabletFreqSugg: tapUniqueArray || []
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // FAVORITE GET
  const getDrugFavoriteList = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_DRUG_FAV)

      if (response?.data?.status === 'success') {
        setMedication((prev) => ({ ...prev, favPrescripSugg: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // MEDICATION TEMPLATE GET ===>
  const getMedicationTemplateData = async () => {
    try {
      const response = await RestAPIService.GetWithoutReplica(Serviceurls.NEW_DOC_NOTES_MEDICATION_TEMPLATE)
      if (response?.data?.status === 'success') {
        setMedication((prev) => ({ ...prev, templateList: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // PREVIOUS MEDICATION GET ===> 
  const getPrevMedicationData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PREV_MEDICATION +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id
      )
      if (response?.data?.status === 'success') {
        setMedication((prev) => ({ ...prev, prevPrescripData: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // MEDICATION DATA GET ====>
  const getMedicationData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_MEDICATION + '?appointment_id=' + props.props.appointment_id)
      if (response?.data?.status === 'success') {
        const responseData = response?.data?.data;
        let MedTaperData = responseData?.flatMap(item => item.medication)
        const today = DateTime.now().startOf('day');
        if (medication.templateClicked) {
          responseData?.forEach(group => {
            group.medication?.forEach(med => {

              if (med?.tapper_meds?.length > 0) {
                let allTapperDates = [];
                med.tapper_meds?.forEach(tap => {
                  if (tap.start_date) {
                    let parsedDate = DateTime.fromISO(tap.start_date);
                    if (!parsedDate.isValid) parsedDate = DateTime.fromFormat(tap.start_date, 'dd-MM-yyyy');
                    if (parsedDate.isValid) allTapperDates.push(parsedDate);
                  }
                });

                if (allTapperDates.length > 0) {
                  const minDate = DateTime.min(...allTapperDates);
                  const dayOffset = Math.floor(today.diff(minDate.startOf('day'), 'days').days);
                  if (dayOffset !== 0) {
                    med.tapper_meds?.forEach(tap => {
                      let oldStart = DateTime.fromISO(tap.start_date);
                      let oldEnd = DateTime.fromISO(tap.end_date);
                      if (!oldStart.isValid) oldStart = DateTime.fromFormat(tap.start_date, 'dd-MM-yyyy');
                      if (!oldEnd.isValid) oldEnd = DateTime.fromFormat(tap.end_date, 'dd-MM-yyyy');

                      if (oldStart.isValid && oldEnd.isValid) {
                        tap.start_date = oldStart.plus({ days: dayOffset }).toFormat('yyyy-MM-dd');
                        tap.end_date = oldEnd.plus({ days: dayOffset }).toFormat('yyyy-MM-dd');
                      }
                    });
                  }
                }
              }
            });
          });
        }


        setMedication((prev) => ({
          ...prev,
          medicationList: responseData?.length > 0 ? responseData : [],
          MediTaperData: MedTaperData,
          dupMediTaperData: JSON.stringify(MedTaperData),
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // MEDICATION PRINT ====>
  const getMedicationPrint = async () => {
    try {
      const response = await RestAPIService.getAllPrint(Serviceurls.NEW_DOC_NOTES_MEDICATION +
        '?appointment_id=' + props?.props?.appointment_id + '&language=' + medication.selectedLanguage?.value + '&export_type=pdf'
      )
      if (response) {
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        setMedication((prev) => ({ ...prev, printLoad: false }))
      }
    } catch (error) {
      setMedication((prev) => ({ ...prev, printLoad: false }))
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // MEDICATION POST ===>
  const postMedicationData = async () => {
    try {
      setMedication((prev) => ({ ...prev, btnClked: true }));
      let mediData = [];
      if (medication.favSaveClicked) {
        mediData = [...medication.MediTaperData, ...medication.selectedFavPrescrip]
      } else if (medication.fromPrevPrespAdd) {
         const updatedPrevPrescripData = medication.prevPrescripData.map(item => ({
          ...item,
          id: null
        }));
        mediData = [...medication.MediTaperData, ...updatedPrevPrescripData]
      } else if (medication.selectedTemplate !== null && medication.templateClicked) {
        mediData = [...medication.MediTaperData, ...medication.selectedTemplate?.medication]
      } else if (medication.isEdit) {
        let medication_list = {
          id: medication.selectedId || null,
          pharmacy_id: medication.externalDrug ? null : medication.selectedPharmacy?.pharmacy_id,
          drug_ms_id: medication.drugId,
          drug_name: medication.medSearchDrug || medication.extSearchDrug || medication.tapSearchDrug,
          generic_name: medication.medGenericName || medication.extGenericName || medication.tapGenericName,
          dosage_type: medication.dosageType,
          drug_strength: medication.dosageStrength,
          eye_type: medication.selectedEye === 'Right Eye (OD)' ? 'RE' : medication.selectedEye === 'Left Eye (OS)' ? 'LE' : 'BE',
          is_tapper_meds: medication.tapMedDetails?.length > 0 ? true : false,
          is_favorite: medication.medFavorite || false,
          opt_template_line_id: null,
          duration: `${medication.durationTime} ${medication.durationType}`,
          duration_mode: medication.durationType,
          instructions: medication.tapMedDetails?.length === 0 ? medication.selectedUsage : '',
          comments: medication.medExtTapComments,
          morning: 0,
          afternoon: 0,
          evening: 0,
          night: 0,
          quantity: medication.quantity,
          tapper_meds: medication.tapMedDetails,
          frequency: medication.selectedFreq,
          is_external_drug: medication.externalDrug,
          selective_days:medication?.selective_days?.map(item => convertDayToNumber(item)) || [],
          fo_external_drug_id: medication.externalDrug ? medication.fo_external_drug_id : null
        }
        const updatedData = [...medication.MediTaperData]
        mediData = updatedData?.map((item) => item?.id === medication.selectedId ? medication_list : item)
      } else {
        mediData = [...medication.MediTaperData]
      }
      let data = {
        appointment_id: props.props.appointment_id,
        followup_date: null,
        medication: mediData,
        language: medication.selectedLanguage?.value || 'English',
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_MEDICATION)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getMedicationData()
        await getPrevMedicationData()
        await getDrugFavoriteList()
        setMedication((prev) => ({
          ...prev,
          openMedicationPopup: false, openPrevPrescripPopup: false,
          fromPrevPrespAdd: false, openFavPrescripPopup: false,
          favSaveClicked: false, isEdit: false, selectedId: null,
          templateClicked: false, isLftEdit: false, AfterApi: false,
          btnClked: false,
        }))
        
        const isExternalDrug = medication.MediTaperData?.some(item => item.is_external_drug === true) || medication.externalDrug;
        if (is_save_transmit &&
          (!medication.favSaveClicked &&
            !medication.fromPrevPrespAdd &&
            !medication.templateClicked &&
            !medication.isEdit && 
            !isExternalDrug)) {
          const item = {
            transmitted_pharmacy_id: medication?.medicationList[0]?.transmitted_pharmacy_id || medication.selectedPharmacy?.pharmacy_id
          }
          postMedicationTransmitRecall(item, false, is_save_transmit);
        }
        onClearHandler()
      }

    } catch (error) {
      setMedication((prev) => ({ ...prev, btnClked: false }));
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // TRANSMIT AND RECALL POST====>
  const postMedicationTransmitRecall = async (item, recall, fromSaveTransmit = false) => {
    try {
      setMedication((prev) => ({ ...prev, btnClked: fromSaveTransmit }));
      let data = {
        appointment_id: props.props.appointment_id,
        pharmacy_id: item?.transmitted_pharmacy_id,
        is_recall: recall,
        time: new Date().toISOString(),
        recalled_reason: recallReason
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_MEDICATION_TRANSMIT)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        setMedication((prev) => ({ ...prev, btnClked: false }));
        await getMedicationData()
      }
    } catch (error) {
      setMedication((prev) => ({ ...prev, btnClked: false }));
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // TEMPLATE POST ===> 
  const postMedicationTemplate = async () => {
    try {
      medication.MediTaperData?.map((item) => item.line_id = item?.line_id ? item.line_id : null)
      let data = {
        template_id: medication.templateId || null,
        template_name: medication.templateName || '',
        medication: medication.MediTaperData
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_MEDICATION_TEMPLATE)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getMedicationTemplateData()
        setMedication((prev) => ({
          ...prev,
          openAddNewTemplatePopup: false,
          templateName: '',
          templateId: null,
          templateClicked: false,
          selectedTemplate: medication.tempType === 'add' ? medication.selectedTemplate : null
        }))
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }
  // FREQUENCY DELETE ====>
  const deleteFrequencyData = async (key, index) => {
    try {
      if (JSON.parse(medication.dupFreqSugg)?.includes(key)) {
        const response = await RestAPIService.delete(Serviceurls.DOC_OPT_MEDICATION_FREQUENCY + '?description=' + encodeURIComponent(key))
        if (response?.data?.status === 'success') {
          successMessage(response?.data?.message)
          await getFrequenctList()
        }
      } else {
        let freq = [...medication.FreqSugg]
        freq?.splice(index, 1)
        setMedication((prev) => ({ ...prev, FreqSugg: freq }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // TEMPLATE DELETE
  const deleteMedicationTemplate = async (item) => {
    try {
      let data = {
        id: item.id
      }
      const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_MEDICATION_TEMPLATE, data)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getMedicationTemplateData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // MEDICATION DELETE WITH ID ====>
  const deleteMedicationData = async (item) => {
    try {
      let data = { id: item.id }
      const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_MEDICATION, data)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getMedicationData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  // DELETE MEDICATION LEFT SIDE WITHOUT ID
  const onDeleteLftHandler = (index, fromTaper = false) => {
    try {
      let mediTaperList = [...medication.MediTaperData]
      let withTaperMed = []; let withOutTaperMed = [];
      mediTaperList?.forEach(element => {
        (element?.tapper_meds?.length ? withTaperMed : withOutTaperMed).push(element)
      })
      if (fromTaper) {
        withTaperMed?.splice(index, 1)
      } else {
        withOutTaperMed?.splice(index, 1)
      }
      setMedication((prev) => ({
        ...prev,
        MediTaperData: [...withOutTaperMed, ...withTaperMed]
      }))
    } catch (error) {
      errorMessage(error.message)
    }
  }
  // FOR BOTH MEDICATION TABLE AND POPUP LEFT SCREEN EDIT
  const onEditHandler = (item) => {
    try {
      const hasTapperMeds = item?.tapper_meds?.length > 0
      const isExternal = item?.is_external_drug
      const drugValue = item?.duration?.split(" ");
      const [numStr, textStr] = drugValue?.length === 1 ? [drugValue, 'Days'] : drugValue?.length >= 2 ? drugValue : ["", item?.duration];
      setMedication((prev) => ({
        ...prev,
        selectedId: item?.id,
        medSearchDrug: !isExternal && !hasTapperMeds ? item?.drug_name : null,
        medGenericName: !isExternal && !hasTapperMeds ? item?.generic_name : null,
        tapSearchDrug: hasTapperMeds ? item?.drug_name : null,
        tapGenericName: hasTapperMeds ? item?.generic_name : null,
        dosageStrength: item?.drug_strength,
        dosageType: item?.dosage_type,
        selectedEye: item?.eye_type === 'RE' ? 'Right Eye (OD)' : item?.eye_type === 'LE' ? 'Left Eye (OS)' : 'Both (OU)',
        selectedFreq: item?.frequency,
        durationTime: numStr,
        durationType: textStr,
        selectedUsage: item?.instructions,
        quantity: item?.quantity,
        medFavorite: item?.is_favorite,
        externalDrug: item?.is_external_drug,
        extSearchDrug: isExternal && !hasTapperMeds ? item?.drug_name : null,
        exttapSearchDrug: isExternal && hasTapperMeds ? item?.drug_name : null,
        extGenericName: isExternal ? item?.generic_name : null,
        drugId: item?.drug_ms_id,
        tapMedDetails: hasTapperMeds ? item?.tapper_meds : [],
        medExtTapComments: item?.comments,
        is_from_taper: hasTapperMeds ? true : false,
        selective_days:item?.selective_days?.map(item => convertNumberToDay(item)) || [],
        fo_external_drug_id: isExternal ? item?.fo_external_drug_id : null,

      }))
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onClearHandler = () => {
    setMedication((prev) => ({
      ...prev,
      medSearchDrug: null,
      medSearchDrugSugg: [],
      medGenericName: null,
      medGenericNameSugg: [],
      extSearchDrug: '',
      extSearchDrugSugg: [],
      extGenericName: '',
      extGenericNameSugg: [],
      exttapSearchDrug: '',
      exttapSearchDrugSugg: [],
      exttapGenericName: '',
      exttapGenericNameSugg: [],
      tapSearchDrug: null,
      tapSearchDrugSugg: [],
      tapGenericName: null,
      tapGenericNameSugg: [],
      selectedDate: new Date(),
      tapUnit: '',
      tapUnitType: '',
      tapTabletFreq: null,
      tapDuration: '',
      tapDurationType: 'Day(s)',
      tapDropsFreq: null,
      tapMedDetails: [],
      dosageStrength: '',
      dosageType: '',
      selectedEye: '',
      selectedFreq: '',
      durationTime: '',
      durationType: 'Days',
      selectedUsage: '',
      quantity: '',
      medExtTapComments: '',
      commentsFieldKey: (prev.commentsFieldKey || 0) + 1,
      avalQty: '0',
      dosageTypeSugg: JSON.parse(medication.dupDosageType),
      lftSelectedIndex: null,
      isLftEdit: false,
      rgtTapEdit: false,
      rgtTapIndex: null,
      isEdit: false,
      selectedId: null,
      editData: null,
      fromEdit: false,
      selective_days: [],
      fo_external_drug_id: null,
      highAlert: false,
    }))
  }

  const onClearRightTaperHandler = () => {
    try {
      setMedication((prev) => ({
        ...prev,
        tapSearchDrug: null,
        tapSearchDrugSugg: [],
        tapGenericName: null,
        tapGenericNameSugg: [],
        selectedDate: new Date(),
        tapUnit: '',
        tapUnitType: '',
        tapTabletFreq: null,
        tapDuration: '',
        tapDurationType: 'Day(s)',
        tapDropsFreq: null,
        tapMedDetails: [],
        avalQty: '0',
        selectedUsage: '',
        quantity: '',
        medExtTapComments: '',
        commentsFieldKey: (prev.commentsFieldKey || 0) + 1,
        reduceBy: '',
        selective_days: [],
      }))
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onClearRightMediHandler = () => {
    try {
      setMedication((prev) => ({
        ...prev,
        medSearchDrug: null,
        medSearchDrugSugg: [],
        medGenericName: null,
        medGenericNameSugg: [],
        extSearchDrug: '',
        exttapSearchDrug: '',
        extSearchDrugSugg: [],
        exttapSearchDrugSugg: [],
        extGenericName: '',
        extGenericNameSugg: [],
        exttapGenericName: '',
        exttapGenericNameSugg: [],
        dosageStrength: '',
        dosageType: '',
        selectedEye: '',
        selectedFreq: '',
        durationTime: '',
        durationType: 'Days',
        selectedUsage: '',
        quantity: '',
        medExtTapComments: '',
        commentsFieldKey: (prev.commentsFieldKey || 0) + 1,
        avalQty: '0',
        dosageTypeSugg: JSON.parse(medication.dupDosageType),
        fo_external_drug_id: null,
      }))
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onChangeHandler = (newValue, key) => {
    try {
      let value = newValue
      setMedication((prev) => {
        switch (key) {
          case 'selectedPharmacy':
            return { ...prev, selectedPharmacy: value }
          case 'medSearchDrug':
            if (value) {
              return { ...prev, medSearchDrug: value?.drug_name }
            } else {
              onClearRightMediHandler()
              return { ...prev, medSearchDrug: null }
            }
          case 'medGenericName':
            if (!value) {
              return {
                ...prev,
                medGenericName: "",
                dosageType: "",
                dosageStrength: "",
                medFavorite: false,
                avalQty: "",
                dosageTypeSugg: JSON.parse(medication.dupDosageType) || []
              };
            }
            let hasDosage = JSON.parse(medication.dupDosageType)?.some(item => (item.label)?.toLowerCase() === (newValue?.dosage_type)?.toLowerCase())
            let addDosage = [...JSON.parse(medication.dupDosageType), { value: newValue?.dosage_type, label: newValue?.dosage_type, change_count: 0 }]
            return {
              ...prev,
              medGenericName: value?.generic_name,
              dosageType: value?.dosage_type,
              dosageStrength: value?.dosage_strength,
              medFavorite: value?.is_favorite,
              avalQty: value?.quantity,
              dosageTypeSugg: hasDosage ? JSON.parse(medication.dupDosageType) : addDosage,
            }
          case 'extSearchDrug':
            if (value) {
              return {
                ...prev,
                extSearchDrug: medication.fromEdit ? medication.extSearchDrug : value?.drug_name || value,
                extGenericName: medication.fromEdit ? medication.extGenericName : value?.generic_name,
                dosageType: medication.fromEdit ? medication.dosageType : value?.dosage_type,
                dosageStrength: medication.fromEdit ? medication.dosageStrength : value?.dosage_strength,
                medFavorite: medication.fromEdit ? medication.medFavorite : value?.is_favorite,
                extSearchDrugSugg: [],
                fo_external_drug_id: medication?.fromEdit ? medication.fo_external_drug_id : value?.fo_external_drug_id || null
              }
            } else {
              onClearRightMediHandler()
              return { ...prev }
            }
          case 'exttapSearchDrug':
            if (value) {
              return {
                ...prev,
                exttapSearchDrug: medication.fromEdit ? medication.exttapSearchDrug : value?.drug_name || value,
                exttapGenericName: medication.fromEdit ? medication.exttapGenericName : value?.generic_name,
                dosageType: medication.fromEdit ? medication.dosageType : value?.dosage_type,
                dosageStrength: medication.fromEdit ? medication.dosageStrength : value?.dosage_strength,
                medFavorite: medication.fromEdit ? medication.medFavorite : value?.is_favorite,
                exttapSearchDrugSugg: [],
                fo_external_drug_id: medication?.fromEdit ? medication.fo_external_drug_id : value?.fo_external_drug_id || null
              }
            } else {
              onClearRightTaperHandler()
              return { ...prev }
            }
          case 'extGenericName':
            return { ...prev, extGenericName: value }
          case 'dosageStrength':
            return { ...prev, dosageStrength: value }
          case 'tapSearchDrug':
            if (value) {
              return { ...prev, tapSearchDrug: value?.drug_name }
            } else {
              onClearRightTaperHandler()
              return { ...prev }
            }
          case 'tapGenericName':
            return {
              ...prev,
              drugId: (value?.drug_ms_id || value?.drug_id),
              tapGenericName: value?.generic_name,
              dosageStrength: value?.dosage_strength,
              dosageType: value?.dosage_type,
              avalQty: value?.quantity || 0,
              medFavorite: value?.is_favorite,
              tapUnitType: value?.dosage_type?.toLowerCase()?.includes(medication.steroidTablet?.toLowerCase()) ? 'Mg' : 'Drops'
            }
          case 'tapDropsFreq':
            return { ...prev, tapDropsFreq: value?.label }
          case 'quantity':
            if (CommonValidation.numberOnly(value) || value === '') {
              return { ...prev, quantity: value }
            } else {
              return { ...prev }
            }
          case 'durationTime':
            if (CommonValidation.numberOnly(value) && value <= 31 || value === '') {
              return { ...prev, durationTime: value }
            } else {
              return { ...prev }
            }
          case 'tapDuration':
            if (CommonValidation.numberOnly(value) && value <= 31 || value === '') {
              return { ...prev, tapDuration: value }
            } else {
              return { ...prev }
            }
          case 'tapUnit':
            if (CommonValidation.numberOnly(value) || value === '') {
              return { ...prev, tapUnit: value }
            } else {
              return { ...prev }
            }
          case 'medExtTapComments':
            if (value?.length <= 1000) {
              return { ...prev, medExtTapComments: value }
            } else {
              return { ...prev }
            }
          default:
            return { ...prev, [key]: value }
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const autocompleteTextBox = (options = [], optionLabel, values, key, width, labels, disable) => {
    try {
      return (
        <Autocomplete
          disabled={disable}
          clearIcon
          freeSolo={medication.externalDrug ? true : false}
          size='small'
          sx={{ width: width }}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel]}
          value={values}
          onChange={(e, newValue) => { onChangeHandler(newValue, key) }}
          onInputChange={(e, newValue, reason) => {
            if (medication.fromEdit) {
              const isNameChanged = medication.medSearchDrug !== newValue;
              setMedication((prev) => ({ ...prev, fromEdit: !isNameChanged ? medication.fromEdit : false }))
            }
            if (medication.externalDrug && reason === "input"){
              onChangeHandler(newValue, key)
            }
          }}
          renderInput={(params) => <TextField
            {...params}
            InputProps={{
              ...params.InputProps, emed_tid: key
            }}
            label={labels}
            onChange={(e) => {
              let value = e.target.value
              if (medication.externalDrug) { setSearchExtBrand(value) } else { setMedDrugSearch(value) }
            }}
          />}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderRecallModal = () => (
    <Dialog
      open={recallModalOpen}
      onClose={() => setRecallModalOpen(false)}
      aria-labelledby="recall-dialog-title"
      aria-describedby="recall-dialog-description"
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0.5vw', marginBottom: '0vw' }}>
          <img 
            className="eMed_DeletePopup_CrossIcon" 
            src={ImagePaths.LabCloseButton.default} 
            alt='Close' 
            onClick={() => {
            setRecallModalOpen(false);
            setRecallReason('');
            setRecallError('');
          }} 
          />
        </div>
      <DialogTitle id="recall-dialog-title">
         Recall Drug
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: '1rem' }} id="recall-dialog-description">
          Please provide a reason for recalling this medication.
        </DialogContentText>
        <TextField
          autoFocus
          multiline
          style={{ marginTop: '1vw' }}
          rows={3}
          fullWidth
          variant="outlined"
          label="Reason for Recall*"
          value={recallReason}
          onChange={(e) => {
            setRecallReason(e.target.value);
            if (e.target.value.trim()) {
              setRecallError('');
            }
          }}
          inputProps={{ maxLength: 150 }}
          error={!!recallError}
          helperText={recallError}
          placeholder="Enter the reason for recalling this medication..."
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setRecallModalOpen(false);
            setRecallReason('');
            setRecallError('');
          }}
          variant="outlined"
          sx={{ textTransform: 'capitalize' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{ textTransform: 'capitalize' }}
          onClick={handleRecallConfirm}
          disabled={!recallReason.trim()}
        >
          Recall
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Handle recall click - open modal
  const handleRecallClick = (medicationItem) => {
    setCurrentMedication(medicationItem);
    setRecallModalOpen(true);
    setRecallReason('');
    setRecallError('');
  };

  // Handle recall confirmation
  const handleRecallConfirm = async () => {
    if (!recallReason.trim()) {
      setRecallError('Reason is required');
      return;
    }

    await postMedicationTransmitRecall(currentMedication, true);
    setRecallModalOpen(false);
    setRecallReason('');
    setRecallError('');
  };


  const textBox = (key, values, labels, width, disable, select, selectValue, selectList, selectKey) => {
    try {
      // let disableDur = selectKey === 'Until_the_Next_Visit' ? true : false
      let disableDur = ['Until_the_Next_Visit', 'Long_Term'].includes(medication.durationType)
      return (
        <Box>
          <TextField
            size='small'
            autoComplete='off'
            disabled={disable || disableDur}
            multiline={key === 'medExtTapComments' ? true : false}
            maxRows={key === 'medExtTapComments' ? 5 : 1}
            sx={{ width: width }}
            value={values}
            onChange={(e) => {
              let value = e.target.value
              onChangeHandler(value, key)
            }}
            InputProps={{ emed_tid: key }}
            label={labels}
          />
          {select ?
            <Select
              size='small'
              sx={{ width: '7dvw' }}
              value={selectValue}
              onChange={(e) => setMedication((prev) => ({ ...prev, [selectKey]: e.target.value }))}
            >
              {selectList?.map((item, index) => {
                return (
                  <MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>
                )
              })}
            </Select> : null}
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const commentsField = (width) => {
    if (medication.ReasonSuggestionList?.length) {
      const value = medication.medExtTapComments || '';
      const matchedOption = value ? medication.ReasonSuggestionList?.find((item) => item?.reason === value) : null;
      const autocompleteValue = matchedOption ?? (value || null);
      return (
        <Autocomplete
          key={`comments-${medication.commentsFieldKey}`}
          freeSolo
          clearIcon
          size="small"
          sx={{ width: width }}
          options={medication.ReasonSuggestionList}
          getOptionLabel={(option) => typeof option === 'string' ? option : option?.reason}
          value={autocompleteValue}
          onChange={(e, value) => onChangeHandler(typeof value === 'string' ? value : (value?.reason ?? ''), 'medExtTapComments')}
          renderOption={(props, option) => (
            <li {...props} style={{ padding: '0vh 1.5vh' }}>
              <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
                <ListItemText
                  primary={
                    option?.reason?.length > 30 ? (
                      <Tooltip title={option.reason} placement="top">
                        <div>{option.reason.slice(0, 21) + '...'}</div>
                      </Tooltip>
                    ) : (
                      option.reason
                    )
                  }
                />
                <Tooltip title="Delete Suggestion" placement="top" arrow>
                  <IconButton
                    edge="end"
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation()
                      removeSuggList(option)
                    }}
                  >
                    <DeleteIcon sx={{ height: '2.5vh', width: '2.5vw' }} />
                  </IconButton>
                </Tooltip>
              </ListItem>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              inputProps={{ ...params.inputProps, maxLength: 250 }}
              multiline
              maxRows={5}
              label="Comments"
              value={value}
              onChange={(e) => onChangeHandler(e.target.value, 'medExtTapComments')}
            />
          )}
        />
      )
    }
    return (
      <TextField
        key={`comments-tf-${medication.commentsFieldKey}`}
        size="small"
        autoComplete="off"
        multiline
        maxRows={5}
        sx={{ width: width }}
        value={medication.medExtTapComments}
        onChange={(e) => onChangeHandler(e.target.value, 'medExtTapComments')}
        InputProps={{ emed_tid: 'medExtTapComments' }}
        label="Comments"
        inputProps={{ maxLength: 250 }}
      />
    )
  }

  const onChangeChipHandler = (item, names, key, fromTapper) => {
    try {
      setMedication((prev) => {
        switch (names) {
          case 'medSearchDrug':
            if (item[key] === medication[names]) {
              onClearRightMediHandler()
              return { ...prev }
            } else {
              return {
                ...prev, medSearchDrug: item[key], selectedEye: '',
                selectedFreq: '',
                durationTime: '',
                durationType: 'Days',
                selectedUsage: '',
                quantity: '',
                medExtTapComments: '',
                avalQty: '0',
                dosageTypeSugg: JSON.parse(medication.dupDosageType),
              }
            }
          case 'selectedFreq':
            if (item === medication[names]) {
              return { ...prev, selectedFreq: '' }
            } else {
              return { ...prev, selectedFreq: item }
            }
          case 'tapSearchDrug':
            if (item[key] === medication[names]) {
              onClearRightTaperHandler()
              return { ...prev }
            } else {
              return {
                ...prev, tapSearchDrug: item[key],
                selectedDate: new Date(),
                tapUnit: '',
                tapUnitType: '',
                tapTabletFreq: null,
                tapDuration: '',
                tapDurationType: 'Day(s)',
                tapDropsFreq: null,
                tapMedDetails: [],
                avalQty: '0',
                selectedUsage: '',
                quantity: '',
                medExtTapComments: '', reduceBy: ''
              }
            }
          default:
            let updated = {};
            if (item[key] === medication[names]) {
              updated = {
                ...prev,
                [names]: '',
                tapUnitType: ''
              };
            } else {
              updated = {
                ...prev,
                [names]: item[key]
              };
              if (fromTapper) {
                updated.tapUnitType = (item?.[key] === "Drop") ? "Drop" : "Mg";
              }
            }
            return updated;
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderChip = (item, index, disable, type, key, names, fromTapper = false) => {
    try {
      return (
        <Chip
          className={type === 'freq' ?
            `eMed_chip ${item === medication[names] ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}` :
            `eMed_chip ${item[key] === medication[names] ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
          label={type === 'freq' ? item : item[key]}
          variant={'outlined'}
          key={index}
          onClick={() => { onChangeChipHandler(item, names, key, fromTapper) }}
          clickable
          onDelete={type === 'freq' && !fromTapper ? () => deleteFrequencyData(item, index) : null}
          disabled={disable}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderPharmacy = () => {
    return (
      <Box component={'div'} className='doc_med_box'>
        {medication.externalDrug ? <Box width={'20dvw'}></Box> : autocompleteTextBox(medication.pharmacyList, 'pharmacy_name', medication.selectedPharmacy, 'selectedPharmacy', '20dvw', 'Select Pharmacy *')}
        {!medication.isEdit && !medication.fromEdit ?
          <Button
            variant='outlined'
            sx={{ textTransform: 'capitalize' }}
            onClick={() => {
              setMedication((prev) => ({ ...prev, externalDrug: !medication.externalDrug }))
              onClearRightMediHandler()
            }}
          >{medication.externalDrug ? 'Pharmacy Drugs' : 'External Drugs'}</Button> : null}
      </Box>
    )
  }

  const saveButton = () => {
    return (
      <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
        {medication.isEdit ? null :
          <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
            disabled={medication.btnClked}
            onClick={() => postMedicationData()}
          >{is_save_transmit ? "Save & Transmit" : "Save"}</Button>}
      </Box>
    )
  }

  const rgtAddClearButton = () => {
    return (
      <Box component={'div'} borderTop={'1.5px solid lightgray'} p={'0.5rem'} display={'flex'} justifyContent={'center'} alignItems={'center'} className=''>
        {!medication.isEdit ? <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
          onClick={() => onClearHandler()}
        >Clear</Button> : null}
        {medication.isEdit ?
          <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
            onClick={() => postMedicationData()}
          >Update</Button> :
          <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
            onClick={() => onRightAddHandler()}
          >Add</Button>}
      </Box>
    )
  }

  const checkDrugValidation = () => {
    try {
      let message = null;
      const {
        selectedTab, externalDrug, medSearchDrug, medGenericName, extSearchDrug,
        extGenericName, tapSearchDrug, tapGenericName, dosageType, drop, selectedEye,
        selectedFreq, durationTime, dosageStrength, tapMedDetails, exttapSearchDrug, exttapGenericName
      } = medication;

      const isEyeDrop = dosageType?.toLowerCase()?.includes(drop?.toLowerCase());
      const isExternal = externalDrug;

      if (selectedTab === 'one') {
        const searchDrug = isExternal ? extSearchDrug : medSearchDrug;
        const genericName = isExternal ? extGenericName : medGenericName;

        if (!searchDrug) message = 'Enter Drug Details';
        else if (!genericName) message = 'Select Generic Name';
        else if (isExternal && (!dosageType || !dosageStrength)) message = 'Enter Dosage Type and Dosage Strength';
        else if (isEyeDrop && !selectedEye) message = 'Select Eye Type';
        else if (!selectedFreq) message = 'Select Frequency';
        else if (!durationTime) message = 'Enter Duration';
      } else {
        const tappersearchDrug = isExternal ? exttapSearchDrug : tapSearchDrug;
        const tappergenericName = isExternal ? exttapGenericName : tapGenericName;
        if (!tappersearchDrug) message = 'Enter Drug Details';
        else if (!tappergenericName) message = 'Select Generic Name';
        else if (isEyeDrop && !selectedEye) message = 'Select Eye Type';
        else if (!tapMedDetails?.length) message = 'Enter Taper Details';
      }

      return message;
    } catch (error) {
      errorMessage(error.message);
    }
  };

  const onRightAddHandler = () => {
    try {
      let medication_list = {
        id: medication.selectedId || null,
        pharmacy_id: medication.externalDrug ? null : medication.selectedPharmacy?.pharmacy_id,
        drug_ms_id: medication.drugId,
        drug_name: medication.medSearchDrug || medication.extSearchDrug || medication.tapSearchDrug || medication.exttapSearchDrug,
        generic_name: medication.medGenericName || medication.extGenericName || medication.tapGenericName || medication.exttapGenericName,
        dosage_type: medication.dosageType,
        drug_strength: medication.dosageStrength,
        eye_type: medication.selectedEye === 'Right Eye (OD)' ? 'RE' : medication.selectedEye === 'Left Eye (OS)' ? 'LE' : 'BE',
        is_tapper_meds: medication.tapMedDetails?.length > 0 ? true : false,
        is_favorite: medication.medFavorite,
        opt_template_line_id: null,
        duration: `${medication.durationTime} ${medication.durationType}`,
        duration_mode: medication.durationType,
        instructions: medication.selectedUsage,
        comments: medication.medExtTapComments,
        morning: 0,
        afternoon: 0,
        evening: 0,
        night: 0,
        quantity: medication.quantity,
        tapper_meds: medication.tapMedDetails,
        frequency: medication.selectedFreq,
        is_external_drug: medication.externalDrug,
        selective_days: medication?.selective_days?.map(item => convertDayToNumber(item)) || [],
        fo_external_drug_id: medication.externalDrug ? medication.fo_external_drug_id : null
      }
      let checkValidation = checkDrugValidation()
      if (checkValidation === null) {
        if (medication.isLftEdit) {
          let mediTaperList = [...medication.MediTaperData];
          let withTaperMed = [], withOutTaperMed = [];
          mediTaperList.forEach(element =>
            (element?.tapper_meds?.length ? withTaperMed : withOutTaperMed).push(element)
          );
          const updatedList = medication.is_from_taper ? withTaperMed : withOutTaperMed;
          updatedList[medication.lftSelectedIndex] = medication_list;
          setMedication((prev) => ({ ...prev, MediTaperData: [...withTaperMed, ...withOutTaperMed] }));
        } else {
          setMedication((prev) => ({ ...prev, MediTaperData: [...prev.MediTaperData, medication_list] }));
        }
        onClearHandler()
      } else {
        errorMessage(checkValidation)
      }

    } catch (error) {
      errorMessage(error.message)
    }
  }


  const MediExtCommonScreen = (fromExt = true) => {
    return (
      <Box component={'div'}>
        {medication.externalDrug ?
          <Box component={'div'} className='doc_med_margin_top'>
            <Typography className='doc_notes_header_card_font'>Dosage Type *</Typography>
            <Box component={'div'} className=''>
              {medication.dosageTypeSugg?.length > 0 ? medication.dosageTypeSugg?.map((item, index) => {
                return (renderChip(item, index, fromExt, '', 'label', 'dosageType'))
              }) : null}
            </Box>
          </Box> : null}
        <Box component={'div'} className='doc_med_margin_top'>
          <Typography className='doc_notes_header_card_font'>{medication.dosageType?.toLowerCase()?.includes(medication.drop?.toLowerCase()) ? 'Select Eye *' : 'Select Eye'}</Typography>
          <Box component={'div'} className=''>
            {medication.eyeList?.length > 0 ? medication.eyeList?.map((item, index) => {
              return (renderChip(item, index, false, '', 'show_label', 'selectedEye'))
            }) : null}
          </Box>
        </Box>
        <Box component={'div'} className='doc_med_margin_top'>
          <Typography className='doc_notes_header_card_font'>Frequency *</Typography>
          <Box component={'div'} className='' display={'flex'} flexWrap='wrap' alignItems={'center'}>
            {medication.FreqSugg?.length > 0 ? medication.FreqSugg?.map((item, index) => {
              return (renderChip(item, index, false, 'freq', '', 'selectedFreq'))
            }) : null}
            <TextField
              size='small'
              sx={{ width: '10dvw' }}
              value={medication.newFreq}
              onChange={(e) => setMedication((prev) => ({ ...prev, newFreq: e.target.value }))}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setMedication((prev) => ({
                    ...prev,
                    FreqSugg: [...medication.FreqSugg, medication.newFreq],
                    selectedFreq: medication.newFreq,
                    newFreq: ''
                  }))
                }
              }}
              InputProps={{ style: { height: COMMON_STYLE.HEIGHT } }}
            />
          </Box>
        </Box>
        <br />
        <Box>
          <Typography className='doc_notes_header_card_font'>Select Days</Typography>
          {(localGetItem('show_selective_days_in_prescription') === "true") ?(
        <FormControl sx={{ m: 1, width: '28.8vw' }} size='small'>
          <InputLabel >Select Days</InputLabel>
          <Select
            size='small'
            multiple
            value={medication.selective_days}
            onChange={handleChange}
            input={<OutlinedInput label="Select Days" />}
          >
            {Prescription_Days.map((days) => (
              <MenuItem
                key={days}
                value={days}
              >
                {days}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        ) : null} 
        </Box>
        <Box component={'div'}>
          <Typography className='doc_notes_header_card_font'>Duration *</Typography>
          <Box component={'div'} className='doc_med_box'>
            {textBox('durationTime', medication.durationTime, '', '5dvw', false, true, medication.durationType, medication.durationTypeSugg, 'durationType')}
            <FormControl size='small' sx={{ width: '15dvw' }}>
              <InputLabel>Select Usage</InputLabel>
              <Select
                label='Select Usage'
                value={medication.selectedUsage}
                onChange={(e) => {
                  setMedication((prev) => ({
                    ...prev,
                    selectedUsage: e.target.value
                  }))
                }}
              >
                {medication.usageSugg?.map((item, index) => {
                  return (<MenuItem key={index} value={item.value}>{item?.label}</MenuItem>)
                })}
              </Select>
            </FormControl>
            {textBox('quantity', medication.quantity, 'Quantity', '10dvw')}
          </Box>
        </Box>
        <Box component={'div'} mt={'0.5rem'}>
          <Typography className='doc_notes_header_card_font'>Other Details</Typography>
          <Box component={'div'} className='doc_med_box'>
            {commentsField('38dvw')}
          </Box>
        </Box>
        {medication.externalDrug ?
          <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} mt={'0.5rem'}>
            <Typography fontWeight={600} fontSize={'0.8rem'} color={Colors.red}>{`Note : This Drug is not available in our pharmacy`}</Typography>
          </Box> : null}
      </Box>
    )
  }

  const MediTaperTbl = (tblData = [], fromTaper = false) => {
    return (
      <Box component={'div'}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell className='doc_notes_tbl_header' width={'30%'}>Brand Name</TableCell>
              <TableCell className='doc_notes_tbl_header' width={'20%'}>Frequency</TableCell>
              <TableCell className='doc_notes_tbl_header' width={'20%'}>Duration</TableCell>
              <TableCell className='doc_notes_tbl_header' width={'10%'}>Usage</TableCell>
              <TableCell className='doc_notes_tbl_header' width={'10%'} align='center'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tblData?.length > 0 ? tblData?.map((item, index) => {
              let brandName = `${item?.drug_name} - ${item?.generic_name}`
              let dosage = `${item?.dosage_type} - ${item?.drug_strength}`
              let frequency = item?.frequency
              let duration = `${item?.duration}`
              let instructions = expandInstruction(item?.instructions)
              return (
                <TableRow key={index}>
                  <TableCell className='doc_notes_tbl_body_cell'>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                      {item?.is_favorite ? <StarIcon color='primary' /> : <StarBorderIcon color='primary' />}
                      <Box component={'div'} ml={'0.5rem'}>
                        {brandName ? brandName?.length > 30 ?
                          <Tooltip placement='top' title={brandName}><Typography fontSize={'0.9rem'} fontWeight={600}>{brandName?.slice(0, 30) + '...'}</Typography></Tooltip> :
                          <Typography fontSize={'0.9rem'} fontWeight={600}>{brandName}</Typography> : '-'}
                        {dosage ? dosage?.length > 30 ?
                          <Tooltip placement='top' title={dosage}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{dosage?.slice(0, 30) + '...'}</Typography></Tooltip> :
                          <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{dosage}</Typography> : '-'}
                      </Box>
                    </Box>
                  </TableCell>
                  {item?.tapper_meds?.length === 0 ?
                    <TableCell className='doc_notes_tbl_body_cell'>{frequency}</TableCell> :
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'}>
                        {item?.tapper_meds?.map((tapItem, tapIndex) => {
                          let frequency = tapItem?.frequency
                          let startEndDate = `${formatDate(tapItem.start_date)}-${formatDate(tapItem?.end_date)}`
                          return (
                            <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                              {frequency ? frequency?.length > 15 ?
                                <Tooltip placement='top' title={frequency}><Typography fontSize={'0.8dvw'} fontWeight={600}>{frequency?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.8dvw'}>{frequency}</Typography> : '-'
                              }
                              {startEndDate?.length > 25 ?
                                <Tooltip placement='top' title={startEndDate}><Typography fontSize={'0.8dvw'}>{startEndDate?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.8dvw'}>{startEndDate}</Typography>
                              }
                            </Box>
                          )
                        })}
                      </Box>
                    </TableCell>}
                  {item?.tapper_meds?.length === 0 ?
                    <TableCell className='doc_notes_tbl_body_cell'>{duration}</TableCell> :
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'}>
                        {item?.tapper_meds?.map((tapItem, tapIndex) => {
                          let duration = `${tapItem.duration}`
                          return (
                            <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                              <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                              <Typography fontSize={'0.9dvw'}>{duration || '-'}</Typography>
                            </Box>
                          )
                        })}
                      </Box>
                    </TableCell>}
                  <TableCell className='doc_notes_tbl_body_cell'>{instructions || '-'}</TableCell>
                  <TableCell className='doc_notes_tbl_body_cell' align='center'>
                    <Box component={'div'}>
                      <IconButton
                        onClick={() => {
                          setMedication((prev) => ({
                            ...prev,
                            isLftEdit: true,
                            lftSelectedIndex: index,
                            editData: item,
                            // medSearchDrug: item?.drug_name,
                            fromEdit: true
                          }))
                          onEditHandler(item)
                        }}
                      ><EditIcon color='primary' /></IconButton>
                      <IconButton
                        onClick={() => {
                          if (item?.id) { deleteMedicationData(item) } else { onDeleteLftHandler(index, fromTaper) }
                        }}
                      ><DeleteIcon color='error' /></IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              )
            }) : <TableRow><TableCell colSpan={6} align='center'>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Box>
    )
  }

  // MEDICATION TAB
  const renderMedicationTab = () => {
    try {
      let medicationRgtData = medication.MediTaperData?.filter(item => item?.tapper_meds?.length === 0)
      return (
        <Box component={'div'} pl={'0.5rem'}>
          <Grid container>
            <Grid xs={7}>
              <Box border={'1px solid lightgray'} maxHeight={'70dvh'} overflow={'auto'}>
                {medication.isEdit ? null : MediTaperTbl(medicationRgtData)}
              </Box>
              <Box component={'div'} mt={'1rem'}>{saveButton()}</Box>
            </Grid>
            <Grid xs={5}>
              <Box component={'div'} border={'1px solid lightgray'}>
                {!medication.externalDrug ? MediRgtScreen() : ExtRgtScreen()}
              </Box>
            </Grid>
          </Grid>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const MediRgtScreen = () => {
    try {
      return (
        <Box component={'div'}>
          <Box component={'div'} p={'0.5rem'} maxHeight={'72dvh'} overflow={'auto'}>
            <Box component={'div'}>{renderPharmacy()}</Box>
            <Box component={'div'} className='doc_med_box'>
              {autocompleteTextBox(medication.medSearchDrugSugg, 'drug_name', medication.medSearchDrug, 'medSearchDrug', '20dvw', 'Search Drug *')}
              {medication.medSearchDrug ?
                <IconButton
                  onClick={() => setMedication((prev) => ({ ...prev, medFavorite: !medication.medFavorite }))}
                >{medication.medFavorite ? <StarIcon color='primary' /> : <StarBorderIcon color='primary' />}</IconButton> : null}
              <Typography className='doc_notes_header_card_font'>{`Available Qty : ${medication.avalQty}`}</Typography>
            </Box>
            <Box component={'div'} className='doc_med_box'>
              {autocompleteTextBox(medication.medGenericNameSugg, 'generic_name', medication.medGenericName, 'medGenericName', '20dvw', 'Select Generic Name *')}
              {textBox('dosageStrength', medication.dosageStrength, 'Dosage Strength *', '9dvw', true)}
              {textBox('dosageType', medication.dosageType, 'Dosage Type *', '9dvw', true)}
            </Box>
            <Box component={'div'} className='doc_med_margin_top'>
              {medication.medDrugFreq?.length > 0 ? medication.medDrugFreq?.map((item, index) => {
                return (renderChip(item, index, '', '', 'drug_name', 'medSearchDrug'))
              }) : null}
            </Box>
            {MediExtCommonScreen()}
          </Box>
          {rgtAddClearButton()}
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const ExtRgtScreen = () => {
    try {
      return (
        <Box component={'div'}>
          <Box component={'div'} p={'0.5rem'} maxHeight={'72dvh'} overflow={'auto'}>
            <Box component={'div'}>{renderPharmacy()}</Box>
            <Box component={'div'} className='doc_med_box'>
              {autocompleteTextBox(medication.extSearchDrugSugg, 'drug_name', medication.extSearchDrug, 'extSearchDrug', '20dvw', 'Search External Drug *')}
                <IconButton
                  onClick={() => setMedication((prev) => ({ ...prev, medFavorite: !medication.medFavorite }))}
                >{medication.medFavorite ? <StarIcon color='primary' /> : <StarBorderIcon color='primary' />}</IconButton> 
              <Typography className='doc_notes_header_card_font'>{`Available Qty : ${medication.avalQty}`}</Typography>
            </Box>
            <Box component={'div'} className='doc_med_box'>
              {autocompleteTextBox(medication.extGenericNameSugg, 'generic_name', medication.extGenericName, 'extGenericName', '20dvw', 'Select External Generic Name *')}
              {textBox('dosageStrength', medication.dosageStrength, 'Dosage Strength *', '18dvw', false)}
            </Box>
            {MediExtCommonScreen(false)}
          </Box>
          {rgtAddClearButton()}
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  // TAPER MED TAB
  const renderTaperMedTab = () => {
    try {
      let taperRgtData = medication.MediTaperData?.filter(item => item?.tapper_meds?.length !== 0)
      return (
        <Box component={'div'} pl={'0.5rem'}>
          <Grid container>
            <Grid xs={7}>
              <Box border={'1px solid lightgray'} maxHeight={'70dvh'} overflow={'auto'}>
                {medication.isEdit ? null : MediTaperTbl(taperRgtData, true)}
              </Box>
              <Box component={'div'} mt={'1rem'}>{saveButton()}</Box>
            </Grid>
            <Grid xs={5}>
              <Box component={'div'}>
                <Box component={'div'} border={'1px solid lightgray'} p={'0.5rem'} height={'72dvh'} overflow={'auto'}>
                  <Box component={'div'}>{renderPharmacy()}</Box>
                  <Box component={'div'} className='doc_med_box'>
                    {medication.externalDrug ?
                      autocompleteTextBox(medication.exttapSearchDrugSugg, 'drug_name', medication.exttapSearchDrug, 'exttapSearchDrug', '20dvw', 'Search External Drug *')
                      :
                      autocompleteTextBox(medication.tapSearchDrugSugg, 'drug_name', medication.tapSearchDrug, 'tapSearchDrug', '20dvw', 'Search Drug *')
                    }
                    {medication.tapSearchDrug || medication?.exttapSearchDrug ?
                      <IconButton
                        onClick={() => setMedication((prev) => ({ ...prev, medFavorite: !medication.medFavorite }))}
                      >{medication.medFavorite ? <StarIcon color='primary' /> : <StarBorderIcon color='primary' />}</IconButton> : null}
                    <Typography className='doc_notes_header_card_font'>{`Available Qty : ${medication.avalQty}`}</Typography>
                  </Box>
                  <Box component={'div'} className='doc_med_box'>
                    {medication.externalDrug ?
                      autocompleteTextBox(medication.exttapGenericNameSugg, 'generic_name', medication.exttapGenericName, 'exttapGenericName', '20dvw', 'Select External Generic Name *')
                      :
                      autocompleteTextBox(medication.tapGenericNameSugg, 'generic_name', medication.tapGenericName, 'tapGenericName', '20dvw', 'Select Generic Name *')}
                    {textBox('dosageStrength', medication.dosageStrength, 'Dosage Strength *', (medication.externalDrug ? '18dvw' : '9dvw'), true)}
                    {medication.externalDrug ? null :
                      textBox('dosageType', medication.dosageType, 'Dosage Type *', '9dvw', true)}
                  </Box>
                  {medication.externalDrug ? (
                    <Box component="div" className="doc_med_margin_top">
                      <Typography className="doc_notes_header_card_font">Dosage Type *</Typography>
                      <Box component="div">
                        {[{ value: 'STEROID TABLETS', label: 'Steroid Tablets', change_count: 0 }, ...(medication.dosageTypeSugg || [])]
                          .map((item, index) =>
                            renderChip(item, index, false, '', 'label', 'dosageType', true)
                          )}
                      </Box>
                    </Box>
                  ) : null}
                  {medication.externalDrug ? null : <Box component={'div'} className='doc_med_margin_top'>
                    {medication.tapDrugFreq?.length > 0 ? medication.tapDrugFreq?.map((item, index) => {
                      return (renderChip(item, index, '', '', 'drug_name', 'tapSearchDrug'))
                    }) : null}
                  </Box>}
                  <Box component={'div'} className='doc_med_box'>
                    {textBox('quantity', medication.quantity, 'Quantity', '10dvw')}
                    <FormControl size='small' sx={{ width: '12dvw' }}>
                      <InputLabel>Select Usage</InputLabel>
                      <Select
                        label='Select Usage'
                        value={medication.selectedUsage}
                        onChange={(e) => {
                          setMedication((prev) => ({
                            ...prev,
                            selectedUsage: e.target.value
                          }))
                        }}
                      >
                        {medication.usageSugg?.map((item, index) => {
                          return (<MenuItem key={index} value={item.value}>{item?.label}</MenuItem>)
                        })}
                      </Select>
                    </FormControl>
                    {commentsField('15dvw')}
                  </Box>
                  {medication.dosageType?.toLowerCase()?.includes(medication.drop?.toLowerCase()) ?
                    <Box component={'div'} className='doc_med_margin_top'>
                      <Typography className='doc_notes_header_card_font'>Select Eye *</Typography>
                      <Box component={'div'} className=''>
                        {medication.eyeList?.length > 0 ? medication.eyeList?.map((item, index) => {
                          return (renderChip(item, index, false, '', 'show_label', 'selectedEye'))
                        }) : null}
                      </Box>
                    </Box> : null
                  }
                  <Box component={'div'} className='doc_med_margin_top'>
                    <Typography className='doc_notes_header_card_font'>Taper Details</Typography>
                    <Box component={'div'} className='doc_med_margin_top'>
                      <Box component={'div'} display={'flex'}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={medication.selectedDate}
                            inputFormat='DD-MM-YYYY'
                            minDate={new Date()}
                            onChange={(newValue) => {
                              setMedication((prev) => ({ ...prev, selectedDate: newValue }))
                            }}
                            renderInput={(params) => <TextField
                              {...params} size='small' sx={{ width: '10dvw', mr: '0.5rem' }}
                              InputProps={{ ...params.InputProps, emed_tid: 'Date' }}
                              label='Select Date'
                            />}
                          />
                        </LocalizationProvider>
                        <Box mr={'0.5rem'}>
                          {textBox('tapDuration', medication.tapDuration, '', '5dvw', false, true, medication.tapDurationType, medication.tapDurationSugg, 'tapDurationType')}
                        </Box>
                        {textBox('tapUnit', medication.tapUnit, 'Unit', '6dvw')}
                        {textBox('tapUnitType', medication.tapUnitType, 'Unit Type', '6dvw', true)}
                      </Box>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        {(medication.dosageType?.toLowerCase() === medication.steroidTablet?.toLowerCase()) || (medication.externalDrug && medication.dosageType?.toLowerCase() !== "drop") ?
                          <Box component={'div'} display={'flex'} mt={'1rem'}>
                            <Box mr={'0.5rem'}>{textBox('reduceBy', medication.reduceBy, 'Reduce By', '10dvw')}</Box>
                            <Box component={'div'}>
                              <Autocomplete
                                size='small'
                                clearIcon
                                freeSolo
                                sx={{ width: '13dvw' }}
                                options={medication.tapTabletFreqSugg}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                                value={medication.tapTabletFreq}
                                onChange={(e, newValue) => {
                                  setMedication((prev) => ({ ...prev, tapTabletFreq: newValue }))
                                }}
                                onInputChange={(e, newValue) => {
                                  setMedication((prev) => ({ ...prev, tapTabletFreq: newValue }))
                                }}
                                renderInput={(params) => <TextField
                                  {...params}
                                  InputProps={{ ...params.InputProps, emed_tid: 'freq' }}
                                  label='Frequency'
                                />}
                              />
                            </Box>
                          </Box> :
                          <Box component={'div'} display={'flex'} mt={'1rem'} alignItems={'center'}>
                            {autocompleteTextBox(medication.tapDropsFreqSugg, 'label', medication.tapDropsFreq, 'tapDropsFreq', '13dvw', 'Select Frequency *')}
                          </Box>}
                        <Box component={'div'}>
                          <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh', ml: '0.5rem', mt: '0.8rem' }}
                            onClick={() => onAddRgtTaperDetails()}
                          >Add</Button>
                        </Box>
                      </Box>
                    </Box>
                    <Box component={'div'} className='doc_med_margin_top' border={'1px solid lightgray'}>
                      <Table size='small'>
                        <TableHead>
                          <TableRow>
                            <TableCell className='doc_notes_tbl_header'>Days</TableCell>
                            <TableCell className='doc_notes_tbl_header'>Unit</TableCell>
                            <TableCell className='doc_notes_tbl_header'>Frequency</TableCell>
                            <TableCell className='doc_notes_tbl_header'>Reduced By</TableCell>
                            <TableCell className='doc_notes_tbl_header' align='center'>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {medication.tapMedDetails?.length > 0 ? medication.tapMedDetails?.map((item, index) => {
                            let startEndDate = `${formatDate(item.start_date)}-${formatDate(item.end_date)}`
                            let unit = `${item?.org_unit} ${item?.org_unitType}`
                            let freq = item?.org_drop_freq || item?.org_tab_freq
                            let reduce = item?.reducedBy
                            let usage = item?.instructions
                            let duration = `${item?.org_duration} ${item?.org_duration_type}`
                            return (
                              <TableRow key={index}>
                                <TableCell>
                                  <Box component={'div'} display={'flex'} alignItems={'center'}>
                                    <Box>
                                      {startEndDate ? startEndDate?.length > 15 ?
                                        <Tooltip placement='top' title={startEndDate}><Typography fontSize={'0.8rem'}>{startEndDate?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={'0.8rem'}>{startEndDate}</Typography> : '-'}
                                      {duration ? duration?.length > 15 ?
                                        <Tooltip placement='top' title={duration}><Typography fontSize={'0.8rem'}>{duration?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={'0.8rem'}>{duration}</Typography> : '-'}
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell>{unit ? unit?.length > 15 ?
                                  <Tooltip placement='top' title={unit}><Typography fontSize={'0.8rem'}>{unit?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                  <Typography fontSize={'0.8rem'}>{unit}</Typography> : '-'}
                                </TableCell>
                                <TableCell>
                                  <Box component={'div'}>
                                    {freq ? freq?.length > 15 ?
                                      <Tooltip placement='top' title={freq}><Typography fontSize={'0.8rem'}>{freq?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                      <Typography fontSize={'0.8rem'}>{freq}</Typography> : '-'}
                                  </Box>
                                </TableCell>
                                <TableCell>{reduce ? reduce?.length > 15 ?
                                  <Tooltip placement='top' title={reduce}><Typography fontSize={'0.8rem'}>{reduce?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                  <Typography fontSize={'0.8rem'}>{reduce}</Typography> : '-'}
                                </TableCell>
                                <TableCell>
                                  <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    <IconButton sx={{ height: '4dvh', width: '2dvw' }}
                                      onClick={() => {
                                        setMedication((prev) => ({
                                          ...prev,
                                          selectedDate: item?.start_date,
                                          tapUnit: item?.org_unit,
                                          tapUnitType: item?.org_unitType,
                                          tapDropsFreq: item?.org_drop_freq,
                                          tapTabletFreq: item?.org_tab_freq,
                                          tapDuration: item?.org_duration,
                                          tapDurationType: item?.org_duration_type,
                                          rgtTapEdit: true,
                                          rgtTapIndex: index,
                                          reduceBy: item?.reducedBy
                                        }))
                                      }}
                                    ><EditIcon color='primary' /></IconButton>
                                    <IconButton sx={{ height: '4dvh', width: '2dvw' }}
                                      onClick={() => {
                                        let tapDatails = [...medication.tapMedDetails]
                                        tapDatails?.splice(index, 1)
                                        setMedication((prev) => ({
                                          ...prev,
                                          tapMedDetails: tapDatails
                                        }))
                                      }}
                                    ><DeleteIcon color='error' /></IconButton>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            )
                          }) : <TableRow><TableCell colSpan={6} align='center'>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                        </TableBody>
                      </Table>
                    </Box>
                  </Box>
                </Box>
                {rgtAddClearButton()}
              </Box>
            </Grid>
          </Grid>
        </Box >
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const checkTaperValidation = (taperDetails) => {
    try {
      let message = null;
      let hasDrops = medication.dosageType?.toLowerCase()?.includes(medication.drop?.toLowerCase())
      if (
        ((medication.tapSearchDrug === null || medication.tapGenericName === null) && (medication.exttapSearchDrug === null || medication.exttapGenericName === null)) ||
        medication.dosageType === '' || medication.dosageStrength === ''
      ) {
        message = 'Enter Drug Details'
      } else if (medication.tapDuration === '' || medication.tapUnit === '') {
        message = 'Enter Taper Details'
      } else if (hasDrops && medication.selectedEye === '') {
        message = 'Select Eye Type'
      } else if (hasDrops && medication.tapDropsFreq === null) {
        message = 'Select Frequency'
      } else if (medication.tapMedDetails?.length > 0) {
        medication.tapMedDetails?.forEach((element, index) => {
          if (medication.rgtTapIndex !== index) {
            if (element?.start_date === taperDetails?.start_date && element?.end_date === taperDetails?.end_date) {
              message = 'Taper Details Already Exists'
            }
          }
        })

      }
      return message
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onAddRgtTaperDetails = () => {
    try {
      let startDate = new Date(medication.selectedDate)
      let newTapStartDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      var duration = medication.tapDuration

      if (medication.tapDurationType === "Week(s)") {
        duration = +(duration) * 7
      } else if (medication.tapDurationType === "Month(s)") {
        duration = +(duration) * 30
      }

      let date = new Date(startDate);
      date.setDate(date.getDate() + (+duration));

      let taperDetails = {
        start_date: newTapStartDate,
        no_of_dosage: `${medication.tapUnit} ${medication.tapUnitType}`,
        duration: `${medication.tapDuration} ${medication.tapDurationType}`,
        end_date: DateTime.fromJSDate(date).toFormat('yyyy-MM-dd'),
        frequency: medication.dosageType?.toLowerCase()?.includes(medication.steroidTablet?.toLowerCase()) ? medication.tapTabletFreq : medication.tapDropsFreq,
        reducedBy: medication.reduceBy || 0,
        org_unit: medication.tapUnit,
        org_unitType: medication.tapUnitType,
        org_duration: medication.tapDuration,
        org_duration_type: medication.tapDurationType,
        org_drop_freq: medication.tapDropsFreq,
        org_tab_freq: medication.tapTabletFreq,
      }
      let nextDate = new Date(date)
      nextDate.setDate(nextDate.getDate() + 1)
      let checkData = checkTaperValidation(taperDetails)
      if (checkData === null) {
        setMedication((prev) => {
          let medicationData = [...prev.tapMedDetails]
          let updatedTapDetails = prev.rgtTapEdit ?
            medicationData?.map((item, index) => index === medication.rgtTapIndex ? taperDetails : item) :
            [...prev.tapMedDetails, taperDetails];
          let updatedTapDropsFreq = prev.tapDropsFreq;
          if (prev.dosageType?.toLowerCase()?.includes(prev.drop?.toLowerCase())) {
            let index = DROP_FREQ.findIndex(item => item.label === prev.tapDropsFreq);
            updatedTapDropsFreq = index > 0 ? DROP_FREQ[index - 1].label : '1 time a day';
          }
          return {
            ...prev,
            tapMedDetails: updatedTapDetails,
            rgtTapEdit: false,
            rgtTapIndex: null,
            selectedDate: DateTime.fromJSDate(nextDate).toFormat('yyyy-MM-dd'),
            tapUnit: +prev.tapUnit > +prev.reduceBy ? (+prev.tapUnit) - (+prev.reduceBy) : prev.tapUnit,
            tapDropsFreq: updatedTapDropsFreq
          };
        })
      } else {
        errorMessage(checkData)
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderMedicationPopUpScreen = () => {
    return (
      <Box component={'div'}>
        <Dialog open={medication.openMedicationPopup} maxWidth='xl' fullWidth>
          <Box className='doc_medi_popup'>
            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Add Medication</Typography>
              <IconButton
                onClick={() => {
                  setMedication((prev) => ({
                    ...prev, openMedicationPopup: false,
                    isEdit: false, fromEdit: false,
                    selectedIndex: null,
                    selectedTab: 'one',
                    MediTaperData: JSON.parse(medication.dupMediTaperData)
                  }))
                  onClearHandler()
                }}
              ><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'}>
              <Tabs
                value={medication.selectedTab}
                onChange={(e, newValue) => {
                  setMedication((prev) => ({
                    ...prev,
                    selectedTab: newValue,
                    externalDrug: false
                  }))
                  onClearHandler()
                }}
                sx={{ backgroundColor: Colors.DataTblHeaderbg }}
                className='doc_med_tab'
              >
                <Tab value={'one'} disabled={medication.isEdit && medication.selectedTab === 'two' ? true : false} label='Medication' className='doc_tab_header doc_med_tab' />
                <Tab value={'two'} disabled={medication.isEdit && medication.selectedTab === 'one' ? true : false} label='Taper Med' className='doc_tab_header doc_med_tab' />
              </Tabs>
              {medication.selectedTab === 'one' ? renderMedicationTab() : renderTaperMedTab()}
            </Box>
          </Box>
        </Dialog>
      </Box>
    )
  }
  // PREVIOUS MEDICATION POPUP
  const renderPrevPrescriptionPopup = () => {
    try {
      return (
        <Dialog open={medication.openPrevPrescripPopup} maxWidth='md' fullWidth>
          <Box component={'div'} className='doc_addendum_popup'>
            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Previous Medication</Typography>
              <IconButton
                onClick={() => setMedication((prev) => ({ ...prev, openPrevPrescripPopup: false }))}
              ><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Box component={'div'} border={'1px solid lightgray'} maxHeight={'60dvh'} overflow={'auto'}>
                <Table size='small' stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Drug Details</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Frequency</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Duration</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Quantity</TableCell>
                      {/* <TableCell className='doc_notes_tbl_header'>Comments</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {medication.prevPrescripData?.length > 0 ? medication.prevPrescripData?.map((subItem, subIndex) => {
                      let brandGenric = `${subItem?.drug_name} - ${subItem?.generic_name}`
                      let dosageStr = `${subItem?.dosage_type} - ${subItem?.drug_strength}`
                      let frequency = subItem?.frequency
                      let instructions = expandInstruction(subItem?.instructions)
                      return (
                        <TableRow key={subIndex}>
                          <TableCell className='doc_notes_tbl_body_cell'>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                              {subItem?.is_favorite ? <StarIcon color='primary' /> : <StarBorderIcon color='primary' />}
                              <Typography fontSize={'0.9rem'} fontWeight={600} ml={'0.5rem'} mt={'0.2rem'}>{subItem?.eye_type}</Typography>
                            </Box>
                          </TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>
                            <Box component={'div'}>
                              {brandGenric ? brandGenric?.length > 30 ?
                                <Tooltip placement='top' title={brandGenric}><Typography fontSize={'0.9rem'} fontWeight={600}>{brandGenric?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.9rem'} fontWeight={600}>{brandGenric}</Typography> : '-'}
                              {dosageStr ? dosageStr?.length > 30 ?
                                <Tooltip placement='top' title={dosageStr}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{dosageStr?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{dosageStr}</Typography> : '-'}
                            </Box>
                          </TableCell>
                          {subItem?.tapper_meds?.length === 0 ?
                            <TableCell className='doc_notes_tbl_body_cell'>
                              <Typography fontSize={'0.9rem'} fontWeight={600}>{frequency}</Typography>
                              <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{instructions}</Typography>
                            </TableCell> :
                            <TableCell className='doc_notes_tbl_body_cell'>
                              <Box component={'div'}>
                                {subItem?.tapper_meds?.map((tapItem, tapIndex) => {
                                  let no_of_dosage = tapItem?.no_of_dosage
                                  let frequency = tapItem?.frequency
                                  return (
                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                      {no_of_dosage?.length > 25 ?
                                        <Tooltip placement='top' title={no_of_dosage}><Typography fontSize={'0.9rem'} fontWeight={600}>{no_of_dosage?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={'0.9rem'} fontWeight={600}>{no_of_dosage}</Typography>
                                      }
                                      {frequency ? frequency?.length > 15 ?
                                        <Tooltip placement='top' title={frequency}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{frequency?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{frequency}</Typography> : '-'
                                      }
                                    </Box>
                                  )
                                })}
                              </Box>
                            </TableCell>}
                          {subItem?.tapper_meds?.length === 0 ?
                            <TableCell className='doc_notes_tbl_body_cell'>
                              <Typography fontSize={'0.9rem'}>{subItem?.duration}</Typography>
                            </TableCell> :
                            <TableCell className='doc_notes_tbl_body_cell'>
                              <Box component={'div'}>
                                {subItem?.tapper_meds?.map((tapItem, tapIndex) => {
                                  let duration = tapItem?.duration
                                  let startEndDate = `${formatDate(tapItem?.start_date)}-${formatDate(tapItem.end_date)}`
                                  return (
                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                      {duration ? duration?.length > 15 ?
                                        <Tooltip placement='top' title={duration}><Typography fontSize={'0.9rem'} fontWeight={600}>{duration?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={'0.9rem'} fontWeight={600}>{duration}</Typography> : '-'
                                      }
                                      {startEndDate?.length > 25 ?
                                        <Tooltip placement='top' title={startEndDate}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{startEndDate?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{startEndDate}</Typography>
                                      }
                                    </Box>
                                  )
                                })}
                              </Box>
                            </TableCell>}
                          <TableCell className='doc_notes_tbl_body_cell'>
                            <Typography fontSize={'0.9rem'}>{subItem?.quantity}</Typography>
                          </TableCell>
                          {/* <TableCell className='doc_notes_tbl_body_cell'>
                          <Typography fontSize={'0.9rem'}>{subItem?.comments}</Typography>
                        </TableCell> */}
                        </TableRow>
                      )
                    }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                  </TableBody>
                </Table>
              </Box>
              <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mt={'1rem'}>
                <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4.5dvh' }}
                  onClick={() => setMedication((prev) => ({ ...prev, openPrevPrescripPopup: false }))}
                >Cancel</Button>
                <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                  onClick={() => setMedication((prev) => ({ ...prev, fromPrevPrespAdd: true }))}
                >Add</Button>
              </Box>
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }
  // FAVORITE DRUG POPUP
  const renderFavPrescriptionPopup = () => {
    try {
      return (
        <Dialog open={medication.openFavPrescripPopup} maxWidth='xs' fullWidth>
          <Box component={'div'} className='doc_addendum_popup'>
            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Favorite Medication</Typography>
              <IconButton
                onClick={() => setMedication((prev) => ({ ...prev, openFavPrescripPopup: false, selectedFavPrescrip: [] }))}
              ><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} mt={'1rem'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
              <Autocomplete
                clearIcon
                size='small'
                multiple
                sx={{ width: '20vw' }}
                options={medication.favPrescripSugg}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.drug_name}
                value={medication.selectedFavPrescrip}
                limitTags={3}
                autoComplete='off'
                onChange={(event, newValue) => {
                  const hasHighAlert = newValue?.some(
                    item =>
                      item?.is_high_alert === true ||
                      item?.is_look_alike === true ||
                      item?.is_sound_alike === true
                  );

                  if (hasHighAlert && medication?.enable_drug_alert) {
                    setMedication(prev => ({
                      ...prev,
                      selectedDrug: newValue[0]?.['drug_name'] || '',
                      is_high_alert: newValue[0]?.['is_high_alert'] || false,
                      is_look_alike: newValue[0]?.['is_look_alike'] || false,
                      is_sound_alike: newValue[0]?.['is_sound_alike'] || false,
                      lookAlikeDrugs: newValue[0]?.['look_alike_drugs'] || [],
                      SoundAlikeDrugs: newValue[0]?.['sound_alike_drugs'] || [],
                      highAlert: true,
                      FavDrugData: newValue,
                    }));
                    return;
                  }
                  setMedication((prev) => ({ ...prev, selectedFavPrescrip: newValue }))
                }}
                renderInput={(params) => <TextField {...params} label='Select Favorite Prescription' />}
              />
            </Box>
            <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} mt={'1rem'} mb={'0.5rem'}>
              <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4.5dvh' }}
                onClick={() => setMedication((prev) => ({ ...prev, openFavPrescripPopup: false, selectedFavPrescrip: [] }))}
              >Cancel</Button>
              <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                disabled={medication.selectedFavPrescrip?.length === 0}
                onClick={() => {
                  setMedication((prev) => ({ ...prev, favSaveClicked: true }))
                }}
              >Save</Button>
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }
  // TEMPLATE POPUP
  const renderTemplateAddUpdatePopup = () => {
    try {
      return (
        <Dialog open={medication.openAddNewTemplatePopup} maxWidth='xs' fullWidth>
          <Box component={'div'} className='doc_addendum_popup'>
            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>
                {medication.tempType === 'add' ? 'Add New Template' : 'Update Template Name'}
              </Typography>
              <IconButton
                onClick={() => setMedication((prev) => ({
                  ...prev,
                  openAddNewTemplatePopup: false,
                  templateName: '',
                  templateId: null
                }))}
              ><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} mt={'1rem'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
              <TextField
                size='small'
                sx={{ width: '25dvw' }}
                value={medication.templateName}
                label='Enter Template Name'
                onChange={(e) => setMedication((prev) => ({ ...prev, templateName: e.target.value }))}
              />
            </Box>
            <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} mt={'1rem'} mb={'0.5rem'}>
              <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4.5dvh' }}
                onClick={() => {
                  setMedication((prev) => ({
                    ...prev,
                    openAddNewTemplatePopup: false,
                    templateName: '',
                    templateId: null
                  }))
                }}
              >Cancel</Button>
              <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                disabled={medication.templateName === ''}
                onClick={() => { postMedicationTemplate() }}
              >{medication.tempType === 'add' ? 'Add' : 'Update'}</Button>
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }
  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={medication.accordionOpen}
          onChange={(_, isExpanded) => {
            setMedication((prev) => ({ ...prev, accordionOpen: isExpanded }))
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'} width = {"100%"}>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Typography className='doc_notes_header_card_font'>Medication</Typography>
              <Tooltip placement='top' title='History'>
                <IconButton
                  disabled={props?.props?.isLocked || props?.props?.patient_transfered}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMedication((prev) => ({ ...prev, openPrevPrescripPopup: true }))
                  }}
                ><HistoryIcon color={props?.props?.isLocked || props?.props?.patient_transfered ? '' : 'primary'} /></IconButton>
              </Tooltip>
              <Tooltip placement='top' title='Favorite'>
                <IconButton
                  disabled={props?.props?.isLocked || props?.props?.patient_transfered}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMedication((prev) => ({ ...prev, openFavPrescripPopup: true }))}}
                ><StarBorderIcon color={props?.props?.isLocked || props?.props?.patient_transfered ? '' : 'primary'} /></IconButton>
              </Tooltip>
            </Box>
            <Box component={'div'} display={'flex'} alignItems={'center'} onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>
              <Autocomplete
                disabled={props?.props?.isLocked || props?.props?.patient_transfered}
                clearIcon
                size='small'
                sx={{ width: '15dvw', backgroundColor: 'white', mr: '0.5rem' }}
                value={medication.selectedTemplate}
                options={medication.templateList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name}
                onChange={(e, newValue) => {
                  setMedication((prev) => ({
                    ...prev,
                    selectedTemplate: newValue,
                    templateClicked: true
                  }))
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={'Select Template'}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    InputProps={{
                      ...params.InputProps,
                      style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                  />
                )}
                PaperComponent={({ children }) => {
                  return (
                    <Paper component={'div'}>
                      {children}
                      {!medication.selectedTemplate && <Button
                        color="primary"
                        fullWidth
                        sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                        onMouseDown={(e) => {
                          setMedication((prev) => ({
                            ...prev,
                            openAddNewTemplatePopup: true,
                            tempType: 'add',
                            templateName: ''
                          }))
                        }}
                      >
                        Add Template
                      </Button>}
                      {medication.selectedTemplate &&
                        <Box component={'div'}>
                          <Button
                            color="primary"
                            fullWidth
                            sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                            onMouseDown={(e) => {
                              setMedication((prev) => ({
                                ...prev,
                                openAddNewTemplatePopup: true,
                                tempType: 'update',
                                templateName: medication.selectedTemplate?.template_name,
                                templateId: medication.selectedTemplate?.id
                              }))
                            }}
                          >
                            Update
                          </Button>
                        </Box>
                      }
                    </Paper>
                  )
                }}
                renderOption={(props, item) => {
                  return (
                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                      <Box component="li" {...props} width={'100%'}>
                        <Typography>{item?.template_name}</Typography>
                      </Box>
                      {<Button className='Common_Btn_Min_Width'
                        onClick={(e) => { e.stopPropagation(); deleteMedicationTemplate(item) }}
                      ><DeleteIcon color='error' /></Button>}
                    </Box>
                  )
                }}
              />
              <Autocomplete
                clearIcon
                size='small'
                sx={{ width: '10dvw', backgroundColor: 'white' }}
                value={medication.selectedLanguage}
                options={medication.languageList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                onChange={(e, newValue) => {
                  setMedication((prev) => ({ ...prev, selectedLanguage: newValue }))
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    placeholder={'Select Language'}
                    InputProps={{
                      ...params.InputProps,
                      style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                  />
                )}
              />
              <Tooltip placement='top' title='Print'><IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setMedication((prev) => ({ ...prev, printLoad: true }))}}
              ><PrintIcon color='primary' /></IconButton></Tooltip>
              <Tooltip placement='top' title='Add Medication'>
                <IconButton
                  disabled={props?.props?.isLocked || props?.props?.patient_transfered}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMedication((prev) => ({ ...prev, openMedicationPopup: true, selectedTab: 'one' }))}}
                ><AddCircleIcon color={props?.props?.isLocked || props?.props?.patient_transfered ? '' : 'primary'} /></IconButton>
              </Tooltip>
            </Box>
          </Box>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              <Table size='small'>
                <TableBody>
                  {medication?.medicationList?.length > 0 ? medication?.medicationList?.map((item, index) => {
                    let disableTransmit = item?.medication?.every(item => !item.is_transmitted && !item?.is_billed)
                    let enableRecall = item?.medication?.every(item => item.is_transmitted && !item?.is_billed)
                    return (
                      <>
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_header'>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                              <Typography fontWeight={600} fontSize={'0.9rem'} mr={'0.5rem'}>{item?.pharmacy_name}</Typography>
                              {(disableTransmit && !item?.is_external_drug && !is_save_transmit) ?
                                <Tooltip placement='top' title='Transmit'>
                                  <IconButton
                                    disabled={props?.props?.isLocked || props?.props?.patient_transfered}
                                    onClick={() => postMedicationTransmitRecall(item,false)}
                                  ><SyncAltIcon color={props?.props?.isLocked || props?.props?.patient_transfered ? '' : 'primary'} /></IconButton>
                                </Tooltip> : null}
                              {enableRecall && !item?.is_external_drug ?
                                <Tooltip placement='top' title='Recall'>
                                  <IconButton
                                    disabled={props?.props?.isLocked || props?.props?.patient_transfered}
                                    onClick={() => handleRecallClick(item)}
                                  ><RestartAltIcon color={props?.props?.isLocked || props?.props?.patient_transfered ? '' : 'error'} /></IconButton>
                                </Tooltip> : null}
                            </Box>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ padding: 0 }} colSpan={12}>
                            <Collapse in={true}>
                              <Box className='doc_med_tbl'>
                                <Table size='small'>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell className='doc_notes_tbl_header' width={'10.66%'}>Eye</TableCell>
                                      <TableCell className='doc_notes_tbl_header' width={'21.66%'}>Drug Details</TableCell>
                                      <TableCell className='doc_notes_tbl_header' width={'21.66%'}>Frequency</TableCell>
                                      <TableCell className='doc_notes_tbl_header' width={'16.66%'}>Duration</TableCell>
                                      <TableCell className='doc_notes_tbl_header' width={'13.66%'}>Quantity</TableCell>
                                      {/* <TableCell className='doc_notes_tbl_header'>Comments</TableCell> */}
                                      <TableCell className='doc_notes_tbl_header' align='center' width={'13.66%'}>Action</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {item?.medication?.length > 0 ? item?.medication?.map((subItem, subIndex) => {
                                      let brandGenric = `${subItem?.drug_name} - ${subItem?.generic_name}`
                                      let dosageStr = `${subItem?.dosage_type} - ${subItem?.drug_strength}`
                                      let frequency = subItem?.frequency
                                      let instructions = expandInstruction(subItem?.instructions)
                                      return (
                                        <TableRow key={subIndex}>
                                          <TableCell className='doc_notes_tbl_body_cell'>
                                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                              {subItem?.is_favorite ? <StarIcon color='primary' /> : <StarBorderIcon color='primary' />}
                                              <Typography fontSize={'0.9rem'} fontWeight={600} ml={'0.5rem'} mt={'0.2rem'}>{subItem?.eye_type}</Typography>
                                            </Box>
                                          </TableCell>
                                          <TableCell className='doc_notes_tbl_body_cell' style={{ color: (subItem?.high_alert || subItem?.is_high_alert) && medication?.enable_drug_alert ? 'red' : 'inherit' }}>
                                            <Box component={'div'}>
                                              {brandGenric ? brandGenric?.length > 30 ?
                                                <Tooltip placement='top' title={brandGenric}><Typography fontSize={'0.9rem'} fontWeight={600}>{brandGenric?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                                <Typography fontSize={'0.9rem'} fontWeight={600}>{brandGenric}</Typography> : '-'}
                                              {dosageStr ? dosageStr?.length > 30 ?
                                                <Tooltip placement='top' title={dosageStr}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{dosageStr?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{dosageStr}</Typography> : '-'}
                                            </Box>
                                          </TableCell>
                                          {subItem?.tapper_meds?.length === 0 ?
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                              <Typography fontSize={'0.9rem'} fontWeight={600}>{frequency}</Typography>
                                              <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{instructions}</Typography>
                                            </TableCell> :
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                              <Box component={'div'}>
                                                {subItem?.tapper_meds?.map((tapItem, tapIndex) => {
                                                  let no_of_dosage = tapItem?.no_of_dosage
                                                  let frequency = tapItem?.frequency
                                                  return (
                                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                      {no_of_dosage?.length > 25 ?
                                                        <Tooltip placement='top' title={no_of_dosage}><Typography fontSize={'0.9rem'} fontWeight={600}>{no_of_dosage?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                                        <Typography fontSize={'0.9rem'} fontWeight={600}>{no_of_dosage}</Typography>
                                                      }
                                                      {frequency ? frequency?.length > 15 ?
                                                        <Tooltip placement='top' title={frequency}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{frequency?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                                        <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{frequency}</Typography> : '-'
                                                      }
                                                    </Box>
                                                  )
                                                })}
                                              </Box>
                                            </TableCell>}
                                          {subItem?.tapper_meds?.length === 0 ?
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                              <Typography fontSize={'0.9rem'} fontWeight={600}>{subItem?.duration}</Typography>
                                            </TableCell> :
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                              <Box component={'div'}>
                                                {subItem?.tapper_meds?.map((tapItem, tapIndex) => {
                                                  let duration = tapItem?.duration
                                                  let startEndDate = `${formatDate(tapItem?.start_date)}-${formatDate(tapItem.end_date)}`
                                                  return (
                                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                      {duration ? duration?.length > 15 ?
                                                        <Tooltip placement='top' title={duration}><Typography fontSize={'0.9rem'} fontWeight={600}>{duration?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                                        <Typography fontSize={'0.9rem'} fontWeight={600}>{duration}</Typography> : '-'
                                                      }
                                                      {startEndDate?.length > 25 ?
                                                        <Tooltip placement='top' title={startEndDate}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{startEndDate?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                                        <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{startEndDate}</Typography>
                                                      }
                                                    </Box>
                                                  )
                                                })}
                                              </Box>
                                            </TableCell>}
                                          <TableCell className='doc_notes_tbl_body_cell'>
                                            <Typography fontSize={'0.9rem'} fontWeight={600}>{subItem?.quantity ? subItem?.quantity : '0'}</Typography>
                                          </TableCell>
                                          {/* <TableCell className='doc_notes_tbl_body_cell'>
                                            <Typography fontSize={'0.9rem'}>{subItem?.comments}</Typography>
                                          </TableCell> */}
                                          <TableCell className='doc_notes_tbl_body_cell'>
                                            <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                              <IconButton sx={{ height: '4dvh', width: '2dvw' }}
                                                disabled={subItem?.is_transmitted && !subItem.is_external_drug || props?.props?.isLocked || props?.props?.patient_transfered}
                                                onClick={() => {
                                                  const hasTapperMeds = subItem?.tapper_meds?.length > 0
                                                  setMedication((prev) => ({
                                                    ...prev,
                                                    isEdit: true,
                                                    openMedicationPopup: true,
                                                    selectedTab: hasTapperMeds ? 'two' : 'one',
                                                    editData: subItem, fromEdit: true,
                                                  }))
                                                  onEditHandler(subItem)
                                                }}
                                              ><EditIcon color={subItem?.is_transmitted && !subItem.is_external_drug ? '' : 'primary'} /></IconButton>
                                              <IconButton sx={{ height: '4dvh', width: '2dvw' }}
                                                disabled={subItem?.is_transmitted && !subItem.is_external_drug || props?.props?.isLocked || props?.props?.patient_transfered}
                                                onClick={() => { deleteMedicationData(subItem) }}
                                              ><DeleteIcon color={subItem?.is_transmitted && !subItem.is_external_drug ? '' : 'error'} /></IconButton>
                                            </Box>
                                          </TableCell>
                                        </TableRow>
                                      )
                                    }) : <TableRow><TableCell colSpan={6} align='center'>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </>
                    )
                  }) : <TableRow><TableCell align='center' colSpan={2}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                </TableBody>
              </Table>
            </Box>
          </AccordionDetails>
          {renderMedicationPopUpScreen()}
          {renderPrevPrescriptionPopup()}
          {renderFavPrescriptionPopup()}
          {renderRecallModal()}
          {renderTemplateAddUpdatePopup()}
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
        {medication?.highAlert && medication?.enable_drug_alert && !medication.fromEdit ?
          <HighAlertDrugPopup
            selectedDrug={medication?.selectedDrug}
            is_high_alert={medication?.is_high_alert}
            is_lookAlike={medication?.is_look_alike}
            is_soundAlike={medication?.is_sound_alike}
            lookAlikeDrugs={medication?.lookAlikeDrugs}
            soundAlikeDrugs={medication?.SoundAlikeDrugs}
            onCancel={highAlertpopupClose}
            onConfirm={highAlertpopupConfirm}
          /> : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaMedication